import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DropDownListComponent, DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { monthlistFrequencies, quarterlistFrequencies } from 'src/app/Models/commonDetail';
import { CustomField, JobsDetail } from 'src/app/Models/job';
import { ClientService } from '../../../client/client.service';
import { FolderTypeService } from '../../../settings/folder-type/folder-type.service';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';
import { KC_MATERIAL_DATE_FORMATS } from 'src/app/Models/materialDatepickerConfig';
import { CommonService } from 'src/app/shared/common.service';
import { TaskService } from '../../task.service';
import { FeatureFlags } from 'src/app/shared/app.constant';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FeatureFlagService } from 'src/app/commonservice/featureflag.service';
import { JobMilestoneService } from '../../../job/job.service';
import { JobTypeService } from 'src/app/settings/jobtype/jobType.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { DivisionManagementService } from 'src/app/settings/division-management/division-management.service';
import { FirmDetailService } from 'src/app/settings/firm-details/firm-detail.service';
import { DestroyableComponent } from 'src/app/shared/destroyable.component';
import { OfficeService } from 'src/app/settings/services/office.service';
import { TeamsService } from 'src/app/shared/teams.service';
import { Subject, Subscription, timer, firstValueFrom } from 'rxjs';
import { CategoryService } from 'src/app/document/services/category.service';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { selectAllUsers } from 'src/app/store/users/users.selectors';
import { Store } from '@ngrx/store';
import { UserManagementService } from 'src/app/shared/userManagement.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SMClientService } from 'src/app/client/SM-client.service';

interface privilege {
  key: string;
  value: string;
}

interface RolePermissions {
  roleId: number;
  accountingFirmId: number;
  roleName: string;
  roleRate: number;
  area: string;
  privilege: string;
  notification: string;
  privileges: privilege;
  isSystem: boolean;
  defaultRoleName: string;
  description: string;
}

interface periodData {
  monthly: string;
  isEnabled: boolean;
  id: number;
  selctedStartsDate?: any;
  selctedStartsDay?: any;
  selctedStartsMonth?: any;
  ends?: string;
  endmonth?: any;
  EndOfmonth?: any;
  Period_on?: any;
  selctedEndDay?: any;
}

interface periodQuarterlyData {
  quarterly: string;
  isEnabled: boolean;
  id: number;
  selctedQuarterStartsDate?: any;
  selctedQuarterStartsDay?: any;
  selctedQuarterStartsMonth?: any;
  quarterendsby?: any;
  selctedQuarterEndOn?: any;
  quartendmonth?: any;
  quartEndOfmonth?: any;
  selctedQuarterEndDay?: any;
  Period_QtrOn?: any;
}

class UserRates {
  ValueAmt: number = 0;
  valuelabel: string = '';
  isDefault: boolean = false;
}

class AssignedUser {
  userId: string = null;
  fullName: string = null;
  isFirstUserForRole?: boolean = false;
  isTimesheetEntry?: boolean = false;
  isJobLevelUser: boolean = false;
  jobLevelRoleId: number = null;
  jobLevelRoleName: string = null;
  estimate: number = 0;
  unit: any = 0;
  time: any = '';
  cost: any = 0;
  userRates: UserRates[] = [];
  selectedRate: number = 0;
  _previousRoleId?: number = null;
  _previousUserId?: string = null;
  _availableUserOptions?: any[] = []
  _availableRoleOptions?: RolePermissions[] = []
}

@Component({
  selector: 'app-createjob',
   standalone: true,
  templateUrl: './createjob.component.html',
  styleUrls: ['./createjob.component.scss'],
  imports: [
    CommonModule, FormsModule,
    MatTooltipModule, MatSlideToggleModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatButtonModule, MatMenuModule, MatMomentDateModule,
    NgSelectModule, NgMultiSelectDropDownModule, BsDropdownModule, DropDownListModule
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: KC_MATERIAL_DATE_FORMATS }],
})

export class CreatejobComponent extends DestroyableComponent implements OnInit, AfterViewInit, OnDestroy {
  fields: any = { text: 'jobTypeName', value: 'jobTypeId' };
  dropDownListObject: DropDownListComponent;
  jobDataModal = new JobsDetail();
  savedJobData: any = null;
  @ViewChild('cancelsaveJob') cancelsaveJob: ElementRef;
  @ViewChild('clientJobForm') jobForm!: NgForm;
  @ViewChild('container') container: ElementRef;
  @Output() closeCreateEditJobsPopUp = new EventEmitter();
  @Output() GetStandardWorkflowView = new EventEmitter();
  @Input() data: string = '';
  _jobId: number = 0;
  _clientid: any;
  _isAddJob: number = 0;
  @Input() set cid(cid: number) { this._jobId = cid; }
  @Input() set clientid(clientid: number) { this._clientid = clientid; }
  @Input() set isAddJob(isAddJob: number) { this._isAddJob = isAddJob; }
  selectedItems = [];
  files: File[] = [];
  fileList: any;
  fileCount: any;
  @Input() set Page(Page: any) { this.Orgin = Page; }
  isJobRecurrence: boolean;
  jobTypesL: any;
  enttypeId: number = 0;
  mindueDate: Date;
  isFixedJob = false;
  isNonFixedJob = true;
  fyForSelection = [];
  clientCombo: any;
  divisions: any;
  users: any;
  userByRoles: any;
  public jobTemplate: any;
  statuslist: any;
  defaultpartnerid: string;
  defaultmanagerid: string;
  public isEditMode: boolean = false;
  createJobTableShow: boolean = false;
  lastselectedmanager: any;
  lastselectedpartner: any
  public jobsAssignUser = new JobsAssignUser();
  _lstTempAssignee: Array<AssigneeDetails> = [];
  jobAssgineeDetails: Array<AssigneeDetails> = [];
  jobTaskAssgineeDetails: Array<AssigneeDetails> = [];
  _lstTempAssigneeTemp: Array<AssigneeDetails> = [];
  tempassignee: Array<AssigneeDetails> = [];
  public assigneedetails = new AssigneeDetails();
  tempcfqjobitem: Array<CustomField> = [];
  cfqjobitem: Array<CustomField> = [];
  totalassignedtime: any = "0:00";
  totalrate: any = 0;
  datemaxlength: number = 8;
  totalcost: any = "0.00";
  IsDeleteRow: boolean = false;
  TimeErrorMsg: boolean = false;
  public filterPlaceholder: string = 'Search';
  Orgin: any;
  ClientId: any;
  checkBoxIds: any = [];
  public HideQuickjob: boolean;
  public showclientjob: boolean;
  public checkerrordescription: boolean = false;
  clientCode: any;
  clientSearch: any;
  clientShortName: any;
  shortName: string;
  clientEntityType: string;
  clientName: any;
  clientDisplay: any;
  isOpen: boolean = false;
  selectedStatus: string = 'Select status';
  checkDisableButton: boolean = true;
  public statusOrderList: any = [
    { status: 'Not Started' },
    { status: 'In-Progress' },
    { status: 'Review' },
    { status: 'On Hold' },
    { status: 'Completed' }
  ];

  currentScreenActive: any = 1;
  isVisibleRoleRow: boolean = false;
  rates: any[] = [];
  public roleNameListFields = { text: 'Name' };
  public roleNameList: { [key: string]: Object; }[] = [];
  taskassigneesListConfig = {};
  frequencyMonthList = [];
  frequencyQuarterList = [];
  frequencyConfig = {};
  frequencyQuarterConfig = {};

  recurrenceEnableChk: boolean = false;
  carryFwdTaskOption = [
    { id: 0, value: 'None' },
    { id: 1, value: 'Inherited' },
    { id: 2, value: 'From this job' },
    { id: 3, value: 'From the template' }
  ];
  carryFwdAssigneeOption = [
    { id: 0, value: 'None' },
    { id: 1, value: 'Inherited' },
    { id: 2, value: 'From this job' }
  ];
  carryFwdBudgetOption = [
    { id: 0, value: 'None' },
    { id: 1, value: 'Inherited' },

    { id: 3, value: 'From this job' }
  ];
  carryTaskSelectedValue = "Inherited";
  carryAssigneeSelectedValue = "From this job";
  carryBudgetSelectedValue = "Estimate from this job";
  public roles: RolePermissions[];
  jobselectedFrequency = 'None'
  periodDetailForFirm: any = [];
  assignAndEstimate: AssignAndEstimate = new AssignAndEstimate;
  mapAssignAndEstimateCalls: number = 0;
  firmSetting: any = {};
  recurranceData: RecurranceRequest = new RecurranceRequest;
  public recurrenceFeatureFlag: boolean = false;
  public lastTab: number = 2;
  public lastTemplate: any = null;
  allUsers: any[] = [];
  allActiveUsers: any[] = [];
  cfUserDropdownSetting: IDropdownSettings;
  selctedStartsDate: '1st';
  selctedStartsDay: 'Monday';
  selctedStartsMonth: 'July';
  selctedEndDay: '10';
  selctedEndBy: 'On';
  selctedEndOn: 'July';
  EndOfmonth: '1st';
  selctedQuarterStartsDate: '1st';
  selctedQuarterStartsDay: 'Monday';
  selctedQuarterStartsMonth: 'October';
  selctedQuarterEndDay: '10';
  quarterendsby: 'On';
  selctedQuarterEndOn: 'October';
  quartEndOfmonth: '1st';
  public ejsDropdownRoles = { text: 'roleName', value: 'roleId' };
  private compositeSub = new Subscription();
  readonly quarterMapping: { [key: string]: string } = {
    'Q1-Sep': 'July',
    'Q2-Dec': 'October',
    'Q3-Mar': 'January',
    'Q4-Jun': 'April'
  };
  EndOf: { EndOfmonth: string }[] = [];
  QuarterEndOf: { quartEndOfmonth: string }[] = [];
  startsDateMap = {
    1: 1,
    2: 2,
    3: 3,
    4: 4
  };
  startsWeekMap = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday'
  };
  startsMonthMap = {
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June'
  };
  existingJobDetails: any[] = [];
  duplicateJobNames: string[] = [];
  jobCategorydropdownList = [];
  jobCategoryselectedItems = [];
  jobCategorydropdownSettings = {};
  isDebtorClient: boolean;
  debtorClientList: any = [];
  isDebtorClientListAPICalled: boolean = false;
  partnerAndManagerList: any = {};
  validPartnersList: any[] = [];
  validManagersList: any[] = [];
  officeData: any = null;
  private unsubscribe = new Subject<void>();
  public startDateTodayBtnRef: any;
  users$ = this.store.select(selectAllUsers);
  public ownerData: { [key: string]: Object }[] = [];
  public validOwnerData: { [key: string]: Object }[] = [];
  private statusOwnerTimeout: any;

  constructor(private _toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    public datepipe: DatePipe,
    private _clientService: ClientService,
    private el: ElementRef,
    private _folderService: FolderTypeService,
    private stateManagement: SMClientService,
    private modalService: BsModalService,
    private currencyPipe: CurrencyPipe,
    private common: CommonService,
    private taskService: TaskService,
    private featureFlagService: FeatureFlagService,
    private _jobService: JobMilestoneService,
    private _jobTypeService: JobTypeService,
    private userManagementService: UserManagementService,
    private divisionManagementService: DivisionManagementService,
    private firmDetailService: FirmDetailService, private officeService: OfficeService, private teamsService: TeamsService, private categoryService: CategoryService,private store: Store) {
    super();
    this.ClientId = '';
  }

  getUsersDisplayInClientOrJob(key) {
    this.userManagementService.getUsersDisplayInClientOrJob(key).pipe(takeUntil(this.unsubscribe)).subscribe(
      response => {
        this.partnerAndManagerList = response;
        this.validatePartnersAndManagerList();
      }
    )
  }
  validatePartnersAndManagerList() {                                         //Developer: Sasmit, Ticket: CUST-11033, Date: 27-May-2026
    // Determine if we're in edit mode (job already exists)
    const isEditMode = this.isEditMode; // or use your existing edit mode flag

    this.validPartnersList = this.common.validateUserList(
      this.partnerAndManagerList.displayPartners ?? [],
      [this.jobDataModal.partnerId],
      {
        userIdKey: 'userId',
        statusKey: 'inviteStatus',
        isEditMode: isEditMode
      }
    );

    this.validManagersList = this.common.validateUserList(
      this.partnerAndManagerList.displayManagers ?? [],
      [this.jobDataModal.managerId],
      {
        userIdKey: 'userId',
        statusKey: 'inviteStatus',
        isEditMode: isEditMode
      }
    );
  }

  ngOnInit() {
    (this.officeData == null) ? this.initializeOfficeData() : '';
    this.getOfficePermissions();
    if (this._clientid && this.Orgin == "timeSheetPage") {
      this.getClientDataById(this._clientid);
      !this.isDebtorClientListAPICalled ? this.getDebtorClientList({ clientId: this._clientid }) : '';
    }
    this.getTeams();
    this.getExistingJobDetailsForClient();
    this.getFirmDetails();
    this.jobCategorydropdownList = [
      { item_id: 1, item_text: 'Workflow' },
      { item_id: 2, item_text: 'Timesheet' },
      { item_id: 4, item_text: 'Disbursement' }
    ];
    this.jobCategoryselectedItems = [];
    this.jobCategorydropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: false
    };
    this.getPriorityDropdownList();
    this.setFeatureFlag();
    this.getUsersDisplayInClientOrJob('job');
    this.frequencyMonthList = monthlistFrequencies.sort((a, b) => (a?.sequence > b?.sequence) ? 1 : -1);
    this.frequencyQuarterList = quarterlistFrequencies;
    this.frequencyConfig = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.frequencyQuarterConfig = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select all',
      unSelectAllText: 'Unselect all',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.mindueDate = new Date();
    this.clearFreqVal();
    this.taskassigneesListConfig = {
      singleSelection: false,
      idField: 'userId',
      textField: "fullName",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };

    this.cfUserDropdownSetting = {
      singleSelection: false,
      idField: 'id',
      textField: "text",
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: false,
    }
    this.GetPeriodDetailForFirm();
    this.GetFirmTimeSheetSettingById();
    this.getOwnerList();
  }

  initializeOfficeData() {
    this.officeData = {
      officeList: [],
      selectedOfficeId: null,
      canViewOffice: false
    };
  }

  datas: periodData[] = [
    { id: 7, monthly: 'July', isEnabled: false },
    { id: 8, monthly: 'August', isEnabled: false },
    { id: 9, monthly: 'September', isEnabled: false },
    { id: 10, monthly: 'October', isEnabled: false },
    { id: 11, monthly: 'November', isEnabled: false },
    { id: 12, monthly: 'December', isEnabled: false },
    { id: 1, monthly: 'January', isEnabled: false },
    { id: 2, monthly: 'February', isEnabled: false },
    { id: 3, monthly: 'March', isEnabled: false },
    { id: 4, monthly: 'April', isEnabled: false },
    { id: 5, monthly: 'May', isEnabled: false },
    { id: 6, monthly: 'June', isEnabled: false },
  ];
  quarterDatas: periodQuarterlyData[] =
    [
      { id: 1, "quarterly": "Q1-Sep", isEnabled: false },
      { id: 2, "quarterly": "Q2-Dec", isEnabled: false },
      { id: 3, "quarterly": "Q3-Mar", isEnabled: false },
      { id: 4, "quarterly": "Q4-Jun", isEnabled: false },
    ];
  annualDatas: periodData[] =
    [
      { id: 1, "monthly": "Annual", isEnabled: true },
    ];
  StartsDate = [
    { startsId: 1, startsWeek: '1st' },
    { startsId: 2, startsWeek: '2nd' },
    { startsId: 3, startsWeek: '3rd' },
    { startsId: 4, startsWeek: '4th' },
  ];
  QuarterStartsDate = [
    { QstartsId: 1, QStartsweek: '1st' },
    { QstartsId: 2, QStartsweek: '2nd' },
    { QstartsId: 3, QStartsweek: '3rd' },
    { QstartsId: 4, QStartsweek: '4th' },
  ];
  StartsWeek = [
    { WeekId: 1, StartsWeekDay: 'Monday' },
    { WeekId: 2, StartsWeekDay: 'Tuesday' },
    { WeekId: 3, StartsWeekDay: 'Wednesday' },
    { WeekId: 4, StartsWeekDay: 'Thursday' },
    { WeekId: 5, StartsWeekDay: 'Friday' },
    { WeekId: 6, StartsWeekDay: 'Saturday' },
    { WeekId: 7, StartsWeekDay: 'Sunday' }
  ];
  QuarterStartsWeek = [
    { QStartsid: 1, QStartsday: 'Monday' },
    { QStartsid: 2, QStartsday: 'Tuesday' },
    { QStartsid: 3, QStartsday: 'Wednesday' },
    { QStartsid: 4, QStartsday: 'Thursday' },
    { QStartsid: 5, QStartsday: 'Friday' },
    { QStartsid: 6, QStartsday: 'Saturday' },
    { QStartsid: 7, QStartsday: 'Sunday' }
  ];
  StartsMonth = [
    { StartsMonthId: 7, StartMonth: 'July' },
    { StartsMonthId: 8, StartMonth: 'August' },
    { StartsMonthId: 9, StartMonth: 'September' },
    { StartsMonthId: 10, StartMonth: 'October' },
    { StartsMonthId: 11, StartMonth: 'November' },
    { StartsMonthId: 12, StartMonth: 'December' },
    { StartsMonthId: 1, StartMonth: 'January' },
    { StartsMonthId: 2, StartMonth: 'February' },
    { StartsMonthId: 3, StartMonth: 'March' },
    { StartsMonthId: 4, StartMonth: 'April' },
    { StartsMonthId: 5, StartMonth: 'May' },
    { StartsMonthId: 6, StartMonth: 'June' }
  ];
  EndDay = [
    { EndDayid: 1, EndDays: 10 },
    { EndDayid: 2, EndDays: 20 },
    { EndDayid: 3, EndDays: 30 },
    { EndDayid: 4, EndDays: 40 }
  ];
  QuarterEndDay = [
    { QEndDayid: 1, QEndDays: 10 },
    { QEndDayid: 2, QEndDays: 20 },
    { QEndDayid: 3, QEndDays: 30 },
    { QEndDayid: 4, QEndDays: 40 }
  ];
  EndBy = [
    { endId: 2, ends: 'After' }
  ];
  QuarterEndBy = [
    { id: 2, quarterendsby: 'After' }
  ];
  EndOn = [
    { endOnId: 7, endmonth: 'July' },
    { endOnId: 8, endmonth: 'August' },
    { endOnId: 9, endmonth: 'September' },
    { endOnId: 10, endmonth: 'October' },
    { endOnId: 11, endmonth: 'November' },
    { endOnId: 12, endmonth: 'December' },
    { endOnId: 1, endmonth: 'January' },
    { endOnId: 2, endmonth: 'February' },
    { endOnId: 3, endmonth: 'March' },
    { endOnId: 4, endmonth: 'April' },
    { endOnId: 5, endmonth: 'May' },
    { endOnId: 6, endmonth: 'June' }
  ];
  QuarterEndOn = [
    { qEndId: 7, quartendmonth: 'July' },
    { qEndId: 8, quartendmonth: 'August' },
    { qEndId: 9, quartendmonth: 'September' },
    { qEndId: 10, quartendmonth: 'October' },
    { qEndId: 11, quartendmonth: 'November' },
    { qEndId: 12, quartendmonth: 'December' },
    { qEndId: 1, quartendmonth: 'January' },
    { qEndId: 2, quartendmonth: 'February' },
    { qEndId: 3, quartendmonth: 'March' },
    { qEndId: 4, quartendmonth: 'April' },
    { qEndId: 5, quartendmonth: 'May' },
    { qEndId: 6, quartendmonth: 'June' }
  ];

  public teamList: any;
  getTeams() {
    this.jobDataModal.teamId = null;
    this.teamsService.GetTeamsForCombo().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      this.teamList = result;
    });
  }
  getExistingJobDetailsForClient() {
    this._jobService.GetExistingJobDetailsForClient().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      this.existingJobDetails = result;
      this.validateUniqueJobName();
    })
  }

  async setFeatureFlag() {
    this.recurrenceFeatureFlag = await this.featureFlagService.getAccountingFirmFeatureFlag(FeatureFlags.JobRecurrence);

  }
  setRecurrenceFlag() {
    if (!this.isEditMode) {
      if (!this.recurrenceEnableChk) {
        this.lastTab = 3;
      } else {
        if (this.jobselectedFrequency !== 'None') {
          this.lastTab = 3;
        } else {
          this.lastTab = 2;
        }
      }
    }
  }
  onChangeBillRate(event: any, index: number) {
    this._lstTempAssignee[index].rateperHour = event.billrate;
  }

  onFormChange() {
    this.checkDisableButton = Object.keys(this.jobDataModal).length === 0;
  }
  onClientChange() {
    this.jobDataModal.jobTypeId = undefined;
    this.jobCategoryselectedItems = [];
    if (this.debtorClientList.find(item => item.debtorClientId === this.jobDataModal.clientId)) {
      this.isDebtorClient = true;
    } else {
      this.isDebtorClient = false;
    }
  }

  ngAfterViewInit() {
    this.checkDisableButton = true
    this.el.nativeElement
      ?.querySelectorAll('input, textarea')
      .forEach((element: HTMLElement) => {
        this.addEventListener(element, 'input', () => {

          this.checkDisableButton = false;
        });
      });


    this.addEventListener(this.el.nativeElement, 'change', () => {

      this.checkDisableButton = false;
    });
    this.GetRoleList();

    this.compositeSub.add(this.jobForm.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      this.validateUniqueJobName();
    }));
  }
  ngOnChanges() {
    if (!this.recurrenceEnableChk) {
      this.setDefaultRecurrenceDate();
    } else {
      this.recurranceData.Start_ReccDate = null;
      this.recurranceData.Stop_ReccDate = null;
    }
    (this.officeData == null) ? this.initializeOfficeData() : '';
    this.getALLJobTemplate();
    this.getStaffs();
    this.jobDataModal.clientId = undefined;
    this.jobDataModal.templateId = undefined;
    this.jobDataModal.jobTypeId = undefined;
    if (this._isAddJob == 1) {
      this.getFY();
      this.getDivisions();
      this.getJobTypes(0);
      this.getClientsForCombo();
      this.GetCustomFieldsforQuicklinksByRoleforJob(0, 3);
      this.ShowDate();
      if (this.Orgin == "Contactpage" || this.Orgin == "jobprofile") {
        this.showclientjob = true;
        this.HideQuickjob = false;

        if (this._jobId > 0) {
          this.openJobToEdit(this._jobId);
          this.isEditMode = true;
        } else {
          this.isEditMode = false;
          this.ClientId = this.route.snapshot.queryParams["clientId"];
          this.GetClientProfileById(this.ClientId);
          !this.isDebtorClientListAPICalled ? this.getDebtorClientList({ clientId: this.ClientId }) : null;
        }
        this.checkvalidation = false;
      } else {
        if (this._jobId > 0) {
          this.openJobToEdit(this._jobId);
          this.isEditMode = true;
        }
      }

      if (this.Orgin == "headerpage" || this.Orgin == "workflowpage" || this.Orgin == "timeSheetPage") {
        this.showclientjob = false;
        this.HideQuickjob = true;
      }

      if (this._jobId > 0) {
        this.isEditMode = true;
      } else {
        if (this.checkClearData) {
          this.checkClearData = false;
        } else {
          this.isEditMode = false;
        }
      }
    }
  }

  setDefaultRecurrenceDate() {
    if (this.isEditMode) return;
    const fyj = Number(this.jobDataModal?.financialYear);
    if (this.jobselectedFrequency && this.jobselectedFrequency !== 'None' && this.jobDataModal?.financialYear) {
      this.recurranceData.Start_ReccDate = new Date(fyj-1, 6, 1);
      this.recurranceData.Stop_ReccDate = new Date(fyj, 5, 30)
    }
  }

  getShortName(fullName: string): string {
    if (!fullName || !fullName?.trim()) {
      return '';
    }
    const words = fullName.trim().split(" ");
    let shortname = "";
    if (words.length === 1) {
      shortname = words[0].slice(0, 2);
    } else {
      shortname = words[0].slice(0, 1) + words[1].slice(0, 1);
    }
    return shortname.toUpperCase();
  }

  getRoleById(roleId: number) {
    return this.roles.find(x => x.roleId === roleId)
  }
  getUserById(userId: string) {
    return this.users.find(user => user.userId === userId)
  }

  private parseJsonSafe<T>(value: any, fallback: T): T {
    if (value === null || value === undefined || value === '') {
      return fallback;
    }

    if (typeof value !== 'string') {
      return value as T;
    }

    try {
      return JSON.parse(value) as T;
    } catch {
      return fallback;
    }
  }

  getUniqueArrayOfObject<arr>(array: arr[]) {
    return array.map(x => JSON.stringify(x)).filter((value, index, list) => list.indexOf(value) === index) .map(x => this.parseJsonSafe(x, {} as arr));
  }
  getAvailableUsersForTask() {
    const allSelectedAssigneeIds = this.assignAndEstimate.Assign.staff.map(u => u.userId);
    let availableUsersForTask = allSelectedAssigneeIds.map(userId => ({
      userId: userId,
      fullName: this.getUserById(userId)?.fullName || ''
    }));
    availableUsersForTask = this.getUniqueArrayOfObject(availableUsersForTask.filter(x => x.userId));
    return availableUsersForTask;
  }
  manageUserFromAssignToEstimate(assigneeData: AssignedUser = null, eventUser: { userId: string } = null) {
    const list: AssignedUser[] = assigneeData ? [assigneeData] : this.assignAndEstimate.Assign.staff;
    list.forEach(assigneeUser => {
      this.assignAndEstimate?.Estimate.forEach(group => {
        group.tasks.forEach(task => {
          task._estimateDataList.forEach(estimate => {
            const assignedUserForRole = this.assignAndEstimate.Assign.staff.find(u => u.jobLevelRoleId === estimate.roleId && u.userId === eventUser.userId);
            if (estimate.roleId === assigneeUser.jobLevelRoleId) {
              if (assignedUserForRole && !estimate.userId) {
                const firstUser = eventUser ? eventUser : assignedUserForRole;
                const fullName = this.getUserById(firstUser.userId)?.fullName;
                estimate.userId = eventUser.userId;
                estimate.fullName = fullName;
                estimate.initials = this.extractInitialsFromFirstName(fullName);
              } else {
                list.forEach(user => {
                  const fullName = this.getUserById(user.userId)?.fullName;
                  if (user.userId != user._previousUserId) {
                    task._estimateDataList.filter(x => x.roleId === assigneeUser.jobLevelRoleId)?.forEach(estimate => {
                      if (estimate.userId === user._previousUserId) {
                        if (user.userId) {
                          estimate.fullName = fullName;
                          estimate.initials = this.extractInitialsFromFirstName(fullName);
                          estimate.userId = user.userId;
                        } else {
                          estimate.fullName = '';
                          estimate.initials = '';
                          estimate.userId = '';
                        }
                      }
                    })
                    this.setFilteredListForTask(task);
                  }
                })
              }
            }
            this.setFilteredListForTask(task);
          })
          this.createUnsavedEstimatesList(task);
          task._assignedEstimates = task._estimateDataList.filter(x => x.userId);
        })
      })
    })
    this.calculateAssigneeTimeCost();
    this.updateTaskGroupAssigneeOverview();
    this.setUnassignedData();
  }
  manageUserFromEstimateToAssign(task: EstimateTask) {

    this.assignAndEstimate.Assign.staff.forEach(user => {
      user.unit = this.getTotalEstimateForUser(user.userId, user.jobLevelRoleId)
      user.time = this.getTimeFromUnit(user.unit);
    });
    this.updateTaskGroupAssigneeOverview();
    this.calculateAssigneeTimeCost();
    this.setUnassignedData();
  }
  calculateAssigneeTimeCost(assigneeData: AssignedUser = null) {
    const list: AssignedUser[] = assigneeData ? [assigneeData] : this.assignAndEstimate.Assign.staff;
    list.forEach(user => {
      const unit = this.getTotalEstimateForUser(user.userId, user.jobLevelRoleId);
      user.unit = unit;
      user.time = this.getTimeFromUnit(unit);
      user._previousUserId = user.userId;
      this.calculateCost(user);
    })
  }

  async setUnassignedData() {
    const unassignedRolesEstimate: any = {};
    this.assignAndEstimate?.Estimate.forEach(group => {
      group.tasks.forEach(task => {
        task._estimateDataList.forEach(estimate => {
          if (!estimate.userId) {
            let unassigneData = unassignedRolesEstimate[estimate.roleId];
            if (!unassigneData) {
              unassignedRolesEstimate[estimate.roleId] = {
                roleId: estimate.roleId,
                roleName: estimate.roleName,
                unit: 0,
              }
              unassigneData = unassignedRolesEstimate[estimate.roleId];
            }
            unassigneData.unit += estimate.unit;
          }
        })
        this.createUnsavedEstimatesList(task);
      })
    });

    const unassignedRolesList: any[] = Object.values(unassignedRolesEstimate);
    for (const data of unassignedRolesList) {
      let unassigneAssignee = new AssignedUser;
      const unassignedAssigneeIndex = this.assignAndEstimate.Assign.staff.findIndex(x => x.jobLevelRoleId === data.roleId && !x.userId);

      if (unassignedAssigneeIndex !== -1) {
        unassigneAssignee = this.assignAndEstimate.Assign.staff[unassignedAssigneeIndex];
      } else {
        this.assignAndEstimate.Assign.staff.push({
          ...unassigneAssignee,
          jobLevelRoleId: data.roleId,
          jobLevelRoleName: data.roleName,
        });
        const staff = this.assignAndEstimate.Assign.staff;
        unassigneAssignee = staff[staff.length - 1];
        unassigneAssignee.userRates = await this.getRoleLevelRates(data.roleId);
        unassigneAssignee.selectedRate = unassigneAssignee.userRates[0].ValueAmt;
      }
      unassigneAssignee.unit = this.getTotalEstimateForUser(data.userId, data.roleId);
      unassigneAssignee.time = this.getTimeFromUnit(unassigneAssignee.unit),
        unassigneAssignee.cost = this.getUserCost(unassigneAssignee);
    }
    const currentUnassignedRoleIds = unassignedRolesList.map((x: any) => x.roleId);
    if (this.jobDataModal.jobEstimateType === 'Job' ? currentUnassignedRoleIds.length : true) {
      this.assignAndEstimate.Assign.staff = this.assignAndEstimate.Assign.staff.filter(x => {
        if (!x.userId && !x.isJobLevelUser && !x.isFirstUserForRole) {
          if (this.jobDataModal.jobEstimateType === 'Job') {
            return x.unit;
          } else {
            return currentUnassignedRoleIds.includes(x.jobLevelRoleId);
          }
        }
        return true;
      })
    }

    const unassignedRolesAssignee: any = {};
    this.assignAndEstimate.Assign.staff.forEach((staff, index) => {
      if (!staff.userId) {
        unassignedRolesAssignee[staff.jobLevelRoleId] = unassignedRolesAssignee[staff.jobLevelRoleId] ?? [];
        unassignedRolesAssignee[staff.jobLevelRoleId].push(index);
      }
    })

    this.assignAndEstimate.Assign.staff = this.assignAndEstimate.Assign.staff.filter((x, index) => {
      if (unassignedRolesAssignee[x.jobLevelRoleId]?.length > 1) {
        const otherIndexes = unassignedRolesAssignee[x.jobLevelRoleId].filter((x, i) => i > 0);
        return !otherIndexes.includes(index);
      }
      return true;
    })

    this.setFilteredAssignUserOptions();
  }
  getAssigneeJobLevelSavedData(userId: string, roleId: number) {
    return this.jobAssgineeDetails.find(x => ((x.userId === userId) || (!x.userId && !userId)) && x.role === roleId);
  }
  async mapAssignAndEstimate() {
    if (!this.lastTemplate) {
      return;
    };
    this.mapAssignAndEstimateCalls++;
    if (this.mapAssignAndEstimateCalls === 1) {
      await this.runMapAndEstimate();
    }
  }
  async runMapAndEstimate() {
    this.assignAndEstimate = new AssignAndEstimate;
    await this.setDefaultAssignees();
    this.createAssignAndEstimate(this.common.copyObject(this.lastTemplate));
    this.jobTaskAssgineeDetails.forEach((assignee) => {
      this.assignAndEstimate?.Estimate.forEach(x => {
        x.tasks.forEach(task => {
          if (task.taskId === assignee.taskId) {
            task._estimateDataList.push({
              userId: assignee.userId || null,
              fullName: assignee.name || '',
              time: assignee.time,
              unit: assignee.unit,
              initials: this.extractInitialsFromFirstName(assignee.name),
              roleId: assignee.jobLevelRoleId,
              roleName: this.getRoleById(assignee.jobLevelRoleId)?.roleName || '',
              _availableRoles: [],
              _availableUsers: []
            })
          }
          this.createUnsavedEstimatesList(task);
          this.setTaskRoleNames(task);
        })
      })
    })
    this.updateTaskGroupAssigneeOverview();
    this.jobTaskAssgineeDetails.filter(user => user.taskId && user.isFirstUserForRole).forEach((user) => {
      const unit = this.getTotalEstimateForUser(user.userId, user.jobLevelRoleId);
      const roleRates = this.getRoleLevelRates(user.jobLevelRoleId);

      const assigneeUser: AssignedUser = {
        ...new AssignedUser,
        userId: user.userId || null,
        _previousUserId: user.userId || null,
        _previousRoleId: user.jobLevelRoleId,
        estimate: unit,
        unit: unit,
        time: unit ? this.getTimeFromUnit(unit) : user.time,
        fullName: user.name,
        cost: user.cost || 0,
        userRates: user.userId ? user.multiBillrates.map(main => ({
          ValueAmt: main.billrate,
          valuelabel: main.mRdescription,
          isDefault: main.isDefault
        })) : roleRates,
        selectedRate: user.userId ? (user.rateperHour === '-' ? 0 : user.rateperHour) : roleRates[0]?.ValueAmt,
        isFirstUserForRole: true,
        isTimesheetEntry: user.isTimesheetEntry,
        jobLevelRoleId: user.jobLevelRoleId,
        jobLevelRoleName: this.getRoleById(user.jobLevelRoleId)?.roleName,
      };
      const existingAssigneeIndex = this.assignAndEstimate.Assign.staff.findIndex(x => x.jobLevelRoleId === user.jobLevelRoleId);
      if (existingAssigneeIndex == -1) {
        this.assignAndEstimate.Assign.staff.push(assigneeUser);
      } else {
        this.assignAndEstimate.Assign.staff[existingAssigneeIndex] = {
          ...this.assignAndEstimate.Assign.staff[existingAssigneeIndex],
          ...assigneeUser,
          isJobLevelUser: this.assignAndEstimate.Assign.staff[existingAssigneeIndex]?.isJobLevelUser || false
        }
      }
    });

    this.jobTaskAssgineeDetails.filter(user => user.taskId).forEach((user) => {
      const unit = this.getTotalEstimateForUser(user.userId, user.jobLevelRoleId);

      const existingAssignee = this.assignAndEstimate.Assign.staff.find(assignee => assignee.userId === (user.userId || null) && assignee.jobLevelRoleId === user.jobLevelRoleId);

      if (existingAssignee) {
        existingAssignee.unit = unit;
      } else {
        const newAssignee: AssignedUser = {
          ...new AssignedUser,
          userId: user.userId || null,
          _previousUserId: user.userId || null,
          _previousRoleId: user.jobLevelRoleId,
          estimate: unit,
          unit: unit,
          time: unit ? this.getTimeFromUnit(unit) : user.time,
          fullName: user.name,
          cost: user.cost || 0,
          userRates: user.multiBillrates.map(main => ({
            ValueAmt: main.billrate,
            valuelabel: main.mRdescription,
            isDefault: main.isDefault
          })),
          selectedRate: user.rateperHour === '-' ? 0 : user.rateperHour,
          isFirstUserForRole: false,
          isTimesheetEntry: user.isTimesheetEntry,
          jobLevelRoleId: user.jobLevelRoleId,
          jobLevelRoleName: this.getRoleById(user.jobLevelRoleId)?.roleName,
        }
        this.assignAndEstimate.Assign.staff.push(newAssignee)
      }
    })

    this.jobTaskAssgineeDetails.filter(user => !user.taskId).forEach(user => {
      let jobAssigneeUserIndex = this.assignAndEstimate.Assign.staff.findIndex(x => ((x.userId === user.userId) || (!x.userId && !user.userId)) && x.jobLevelRoleId === user.jobLevelRoleId);
      const roleRates = this.getRoleLevelRates(user.jobLevelRoleId);

      const assigneeUser: AssignedUser = {
        ...new AssignedUser,
        userId: user.userId || null,
        _previousUserId: user.userId || null,
        _previousRoleId: user.jobLevelRoleId,
        estimate: user.unit,
        unit: user.unit,
        time: user.unit ? this.getTimeFromUnit(user.unit) : user.time,
        fullName: user.name,
        cost: user.cost || 0,
        userRates: user.userId ? user.multiBillrates.map(main => ({
          ValueAmt: main.billrate,
          valuelabel: main.mRdescription,
          isDefault: main.isDefault
        })) : roleRates,
        selectedRate: user.userId ? (user.rateperHour === '-' ? 0 : user.rateperHour) : roleRates[0]?.ValueAmt,
        isFirstUserForRole: user.isFirstUserForRole,
        isTimesheetEntry: user.isTimesheetEntry,
        jobLevelRoleId: user.jobLevelRoleId,
        jobLevelRoleName: this.getRoleById(user.jobLevelRoleId)?.roleName,
      };
      if (jobAssigneeUserIndex === -1) {
        this.assignAndEstimate.Assign.staff.push(assigneeUser);
      } else {
        this.assignAndEstimate.Assign.staff[jobAssigneeUserIndex] = {
          ...this.assignAndEstimate.Assign.staff[jobAssigneeUserIndex],
          ...assigneeUser,
          isFirstUserForRole: this.assignAndEstimate.Assign.staff[jobAssigneeUserIndex]?.isFirstUserForRole || false,
          isJobLevelUser: this.assignAndEstimate.Assign.staff[jobAssigneeUserIndex]?.isJobLevelUser || false,
        }
      }
    })

    this.calculateAssigneeTimeCost();
    this.setFilteredAssignUserOptions();
    this.updateTaskGroupAssigneeOverview();
    this.setUnassignedData();

    this.mapAssignAndEstimateCalls--;
    if (this.mapAssignAndEstimateCalls >= 1) {
      await this.runMapAndEstimate();
    }
  }

  async onChangeUserForTaskEstimate(task: EstimateTask, estimate: EstimateTaskData) {
    const fullName = this.getUserById(estimate.userId)?.fullName;
    estimate = {
      ...estimate,
      fullName: fullName,
      roleName: this.getRoleById(estimate.roleId)?.roleName,
      initials: this.extractInitialsFromFirstName(fullName),
    };
    let assigneeUser = this.assignAndEstimate.Assign.staff.find(x => x.userId === estimate.userId && x.jobLevelRoleId === estimate.roleId);

    if (!assigneeUser) {
      let firstChoiceAssigneeEmptyIndex = this.assignAndEstimate.Assign.staff.findIndex(x => !x.userId && x.jobLevelRoleId === estimate.roleId && !x.isJobLevelUser);

      if (firstChoiceAssigneeEmptyIndex !== -1) {
        this.assignAndEstimate.Assign.staff[firstChoiceAssigneeEmptyIndex] = {
          ...this.assignAndEstimate.Assign.staff[firstChoiceAssigneeEmptyIndex],
          userId: estimate.userId,
          fullName: estimate.fullName,
          isFirstUserForRole: true
        };
        assigneeUser = this.assignAndEstimate.Assign.staff[firstChoiceAssigneeEmptyIndex];
      } else {
        assigneeUser = {
          ...new AssignedUser,
          userId: estimate.userId,
          fullName: estimate.fullName,
          jobLevelRoleId: estimate.roleId,
          jobLevelRoleName: this.getRoleById(estimate.roleId)?.roleName,
        };

        this.assignAndEstimate.Assign.staff.push(assigneeUser);
      }

      assigneeUser.userRates = await this.getUserRateAsPromise(assigneeUser);
      assigneeUser.selectedRate = assigneeUser.userRates.find(x => x.isDefault).ValueAmt;
    }

    assigneeUser.unit = this.getTotalEstimateForUser(estimate.userId, estimate.roleId);
    assigneeUser.time = this.getTimeFromUnit(assigneeUser.unit),
      assigneeUser.cost = this.getUserCost(assigneeUser);

    this.setFilteredAssignUserOptions();
    task._assignedEstimates = task._estimateDataList.filter(x => x.userId);

    this.manageUserFromEstimateToAssign(task);
  }

  extractInitialsFromFirstName(firstName) {
    return this.getShortName(firstName);
  }

  GetRoleList() {
    this.userManagementService.GetRolesPermissionsByParams().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      this.roles = result.rolePermissions1;
      this.roles = this.roles.filter(x => x.roleName != 'KC Super Admin' && x.roleName != 'KC Support User');
      this.roles.forEach(element => {
        this.roleNameList.push({ Name: element.roleName, roleid: element.roleId })
      });
    }, error => console.error(error));
  };

  public checkClearData: boolean = false;

  cleanJobform(clientJobForm) {
    if (clientJobForm.form) {
      clientJobForm.form.markAsPristine();
      clientJobForm.form.markAsUntouched();
      clientJobForm.form.updateValueAndValidity();

      Object.keys(clientJobForm.form.controls).forEach(controlName => {
        const control = clientJobForm.form.get(controlName);
        if (control) {
          control.setErrors(null);
        }
      });
    }

    this.checkvalidation = false;
    clientJobForm.resetForm();
    this.checkClearData = true;
    this.modalService.hide();
    clientJobForm.submitted = false;
    this.selectedItems = [];
    this.resetJobform();
    this._lstTempAssignee = [];
    this.resetAssignAndEstimate();
    this.totalassignedtime = 0;
    this.totalcost = 0;
    this.totalrate = 0;
    this.createJobTableShow = false;
    this.TimeErrorMsg = false;
    this.lastselectedpartner = this.defaultpartnerid;
    this.lastselectedmanager = this.defaultmanagerid;
    this.checkDisableButton = true;
    this.statusOwnerTimeout = setTimeout(() => {
      this.jobDataModal.statusOwnerId = 0;
    });
  }

  clearclientlist() {
    this.jobDataModal.clientId = undefined;
    if (typeof (this.dropDownListObject) != undefined && this.dropDownListObject != undefined && this.dropDownListObject.value != undefined) {
      try {
        this.dropDownListObject.value = null;
      } catch (e) { }
    }
    this.clearFreqVal();
    this.checkDisableButton = true;
    this.isDebtorClientListAPICalled = false;
    this.modalService.hide();
  }

  openJobToAdd() {
    if (this.jobDataModal.managerId != undefined) {
      this.AddAssigneeStaff(this.jobDataModal.managerId, -1, 1); this.defaultmanagerid = this.jobDataModal.managerId;
    } else { this.defaultmanagerid = undefined; }
    if (this.jobDataModal.partnerId != undefined) {
      timer(1200).pipe(takeUntil(this.unsubscribe)).subscribe(() => { this.AddAssigneeStaff(this.jobDataModal.partnerId, -1, 1); });
    } else { this.defaultpartnerid = undefined; }
  }

  public checkvalidation: boolean = false;

  resetJobform() {
    this.clearFreqVal();
    this.checkvalidation = false;
    this.jobDataModal = new JobsDetail();
    this.jobDataModal.jobId = 0;
    this.jobDataModal.jobName = "";
    this.jobDataModal.financialYear = undefined;
    this.jobDataModal.jobTypeId = undefined;
    this.jobDataModal.clientId = undefined;
    this.jobDataModal.divisionId = undefined;
    this.jobDataModal.partnerId = undefined;
    this.jobDataModal.templateId = undefined;
    this._jobTypeService.GetJobPriorityValues().subscribe(respnse => {
      this.jobPriorityList = respnse;
      if (this.jobDataModal.priority == undefined) {
        const value = this.jobPriorityList.find(item => item.isDefault == true)
        this.jobDataModal.priority = value.jobPriorityId;
      }
    }, error => console.error(error));
    if (this.statuslist?.length > 0) {
      this.selectedStatus = this.statuslist[0]?.data[0]?.statusName;
    }
    this.selectedItems = [];
    this.statuslist = [];
    this.selectedStatus = 'Select status';
    this._lstTempAssignee = [];
    this.resetAssignAndEstimate();
    this.closeCreateEditJobsPopUp.emit();
    this.currentScreenActive = 1
    this.cfqjobitem = [];
    this.GetCustomFieldsforQuicklinksByRoleforJob(0, 3);
    this.ShowDate();
    this.recurrenceEnableChk = false;
    this.lastTab = 2;
    this.recurranceData = new RecurranceRequest();
  }

  OnCheckFixedBilling() {
    this.jobDataModal.billingMethod = true;
  }

  OnCheckNonFixedBilling() {
    this.jobDataModal.billingMethod = false;
  }

  onSelectFilejob(event) {
    let rejectFileDetails: string = '';
    if (event.rejectedFiles.length > 0) {
      for (let i = 0; i < event.rejectedFiles.length; i++) {
        rejectFileDetails = rejectFileDetails + event.rejectedFiles[i].name.trim() + ', ';
      }
      if (rejectFileDetails != '') {
        rejectFileDetails = rejectFileDetails.trim().substring(0, rejectFileDetails.trim().length - 1);
        this._toastr.warning("Sorry! Below files are not supported : " + rejectFileDetails, "File type is not allowed");
      }
    }
    this.files.push(...event.addedFiles);
    this.fileList = this.files;
  }

  triggerDateCalculation: boolean = true;
  onStartDateChange(event: any) {
    if (!event || !event.value) return;

    const newStartDate = (moment as any)(event.value).startOf('day').toDate();

    if (this.jobDataModal.startDate && (moment as any)(this.jobDataModal.startDate).isSame(newStartDate, 'day')) return;

    this.jobDataModal.startDate = newStartDate;

    this.mindueDate = newStartDate;

    if (!this.jobDataModal.dueDate || newStartDate > this.jobDataModal.dueDate) {
      this.jobDataModal.dueDate = new Date(newStartDate);
    }

    if (this.jobDataModal.turnaround != null && this.triggerDateCalculation) {
      this.calculateDueDateFromStartAndTurnaround();
    }
  }
  StopDueDate(event) {
    event.preventDefault();
  }

  onFiltering(term: string, item: any): boolean {
    if (!term) return true;

    const words = term.toLowerCase().trim().split(/\s+/);

    const text = `
    ${item.clientName || ''}
    ${item.clientCode || ''}
  `.toLowerCase();

    return words.every(word => text.includes(word));
}

  createJobTableShowVlaue() {
    this.createJobTableShow = true;
  }

  onItemSelect(item: any, i: number) {
    if (item == undefined) {
      this._lstTempAssignee[i].time = '';
      this._lstTempAssignee[i].role = '-';
      this._lstTempAssignee[i].rateperHour = '-';
      this._lstTempAssignee[i].cost = '-';
    }
    else {
      item = item.userId;

      const assignee = this._lstTempAssignee.findIndex(obj => obj.userId === item);
      if (assignee > -1 && assignee != i) {
        this._lstTempAssignee.splice(i, 1);
        return false;
      }
    }
    this.AddAssigneeStaff(item, i, 0);
    this.CalculateTotalCost();
    this.TimeErrorMsg = false;
    this.checkDisableButton = false;
  }

  AddPartner(item: any) {
    const assignee = this._lstTempAssignee.findIndex(obj => obj.userId === this.lastselectedpartner);
    this.AddAssigneeStaff(item.userId, assignee, 1);
    this.lastselectedpartner = item.userId;
    this.CalculateTotalCost();
  }

  AddManager(item: any) {
    if (!item) {
      /* when manager is deselcted */
      return;
    }
    const assignee = this._lstTempAssignee.findIndex(obj => obj.userId === this.lastselectedmanager);
    if (assignee == 1) {
      this.DeleteAssigneeStaff(item.userId, this._lstTempAssignee.length - 1);
      this.createJobTableShow = true;
      return;
    }
    this.AddAssigneeStaff(item.userId, assignee, 1);
    this.lastselectedmanager = item.userId;
    this.CalculateTotalCost();
  }

  dateFormatSet(event) {
    if (event.target.value != "") {
      if (event.target.value.split('/').length == 2) {
        this.datemaxlength = 9;
      }
      else if (event.target.value.split('/').length == 3) {
        this.datemaxlength = 10;
      }
      else {
        this.datemaxlength = 8;
      }
    }
  }

  setFilteredAssignUserOptions() {
    this.assignAndEstimate.Assign.staff.forEach(user => {

      const currentSelection = user._availableUserOptions?.find(u => u.userId === user.userId);
      user._availableUserOptions = this.getAvailableAssigneesForRole(user.jobLevelRoleId, user.userId);

      if (currentSelection && !user._availableUserOptions.some(u => u.userId === currentSelection.userId)) {
        user._availableUserOptions.push(currentSelection);
      }
      user._availableRoleOptions = this.getAvailableRolesForAssignee(user);
    });
  }

  sortItems(items: any[], teamMembers: any[]): any[] {
    const matched = items.filter(item => teamMembers.includes(item.userId));
    const unmatched = items.filter(item => !teamMembers.includes(item.userId));
    return [...matched, { isSeparator: true, disabled: true }, ...unmatched];
  }

  onAssigneeRoleSelectionFocus(assignedUser: AssignedUser) {
    assignedUser._previousRoleId = assignedUser.jobLevelRoleId;
  }
  onAssigneeSelectionFocus(assignedUser: AssignedUser) {
    assignedUser._previousUserId = assignedUser.userId;
  }
  onAssigneeSelectionChange(event: any, user: AssignedUser) {
    this.setFilteredAssignUserOptions();
    if (event) {
      this.setAssigneeRates(user);
    } else {
      user.userId = null
      user.userRates = [];
      user.selectedRate = 0;
    }

    this.manageUserFromAssignToEstimate(user, event);
    this.setFilteredAssignUserOptions();
  }

  getRoleLevelRates(roleId: number): UserRates[] {
    const roleRate = this.roles.find(r => r.roleId === roleId)?.roleRate ?? 0;
    return [{
      ValueAmt: roleRate,
      valuelabel: 'Role Rate',
      isDefault: true
    }];
  }
  setAssigneeRates(user: AssignedUser) {
    if (!user.userId) {
      if (user.jobLevelRoleId) {
        user.userRates = this.getRoleLevelRates(user.jobLevelRoleId);
        user.selectedRate = user.userRates[0].ValueAmt;
      }
      return;
    }

    const boday = {
      assignUserIds: user.userId
    };

    this._jobService.getAssigneeDetailsForJob(boday).pipe(takeUntil(this.unsubscribe)).subscribe((result) => {
      if (result) {
        const rates = result[0].multiBillrates.map(main => ({
          ValueAmt: main.billrate,
          valuelabel: main.mRdescription,
          isDefault: main.isDefault
        }));
        user.userRates = rates;
        user.selectedRate = result[0].multiBillrates.find(rate => rate.isDefault)?.billrate || 0;

        this.assignAndEstimate.Assign.staff.forEach(assignee => {
          if (assignee.userId === user.userId) {
            assignee.userRates = rates;
            assignee.selectedRate = assignee.selectedRate || result[0].multiBillrates.find(rate => rate.isDefault)?.billrate || 0;
          }
        });
        this.calculateAssigneeTimeCost(user);
      }

    }, (error) => {
      console.error('Error fetching assignee details:', error);
    });
  }

  async getUserRateAsPromise(user: AssignedUser): Promise<UserRates[]> {
    if (!user.userId) {
      if (user.jobLevelRoleId) {
        return this.getRoleLevelRates(user.jobLevelRoleId);
      }
      return [];
    }

    try {
      const payload = { assignUserIds: user.userId };
      const result = await firstValueFrom(this._jobService.getAssigneeDetailsForJob(payload).pipe(takeUntil(this.unsubscribe)));

      if (result?.[0]?.multiBillrates) {
        return result[0].multiBillrates.map(main => ({
          ValueAmt: main.billrate,
          valuelabel: main.mRdescription,
          isDefault: main.isDefault
        }));
      }

      return [];
    } catch (error) {
      console.error('Failed to fetch assignee rates', error);
      return [];
    }
  }

  GetFirmTimeSheetSettingById() {
    this.firmDetailService.GetFirmTimeSheetSettingById().pipe(takeUntil(this.unsubscribe)).subscribe((result: any) => {
      if (result) {
        this.firmSetting = result;
      }
    })
  }

  AddAssigneeStaff(item: any, i: any, val: any) {
    if (item == undefined)
      return;
    const assignee = this._lstTempAssignee.findIndex(obj => obj.userId === item);
    this.jobsAssignUser.assignUserIds = item;
    let data = new JobsAssignUser();
    data.assignUserIds = item;
    this._jobService.getAssigneeDetailsForJob(data).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result) {
        result.forEach((childObj) => {
          if (i > -1) {
            this._lstTempAssignee[i].userId = childObj.userId;
            this._lstTempAssignee[i].role = childObj.name == 'System Admin' ? '-' : childObj.role;
            this._lstTempAssignee[i].rateperHour = childObj.rateperHour == 0 ? "-" : childObj.rateperHour;
            this._lstTempAssignee[i].time = childObj.time;
            this._lstTempAssignee[i].cost = "-";
            this._lstTempAssignee[i].name = childObj.name;
            this._lstTempAssignee[i].isManagerPartner = val;
            this._lstTempAssignee[i]._billrateId = childObj.billRateId;
            this._lstTempAssignee[i].multiBillrates = childObj.multiBillrates.map((i) => { i.getLabel = this.currencyPipe.transform(i.billrate); return i; });
          }
          else {
            this._lstTempAssignee.push({
              userId: childObj.userId, role: childObj.role, name: childObj.name, rateperHour: childObj.rateperHour, time: childObj.time, cost: "-", isManagerPartner: val, multiBillrates: childObj.multiBillrates.map((i) => { i.getLabel = this.currencyPipe.transform(i.billrate); return i; }), _billrateId: childObj.billRateId
            });
          }
          if (assignee > -1 && assignee != i) {
            this._lstTempAssignee.splice(assignee, 1);
          }
          this.totalrate = this.totalrate + childObj.rateperHour;
          this.CalculateTotalCost();

        });
      }
    });
    this.createJobTableShow = true;
  }

  DeleteAssigneeStaff(item: any, index: number) {
    if (this._lstTempAssignee.length > 0) {
      this.IsDeleteRow = true
      this._lstTempAssigneeTemp = this._lstTempAssignee;
      this._lstTempAssignee = [];
      const assignee = this._lstTempAssigneeTemp.findIndex(obj => obj.userId === item);
      if (index > -1) {
        this._lstTempAssigneeTemp.splice(index, 1);
      }
      else {
        if (assignee > -1) {
          this._lstTempAssigneeTemp.splice(assignee, 1);

        }
      }
      let sumcost: any = "0";
      let etime: any = "0";
      let rate: any = "0";

      for (let i = 0; i < this._lstTempAssigneeTemp.length; i++) {
        sumcost = this.ConvertNumberToTimeinJobs(parseFloat(sumcost) + parseFloat(this._lstTempAssigneeTemp[i].cost == "-" ? 0 : this._lstTempAssigneeTemp[i].cost));
        etime = this.CalculateTotalTimeforJob(parseFloat(etime), parseFloat((this._lstTempAssigneeTemp[i].time == "-" || this._lstTempAssigneeTemp[i].time == "") ? 0 : this._lstTempAssigneeTemp[i].time));
        rate = this.ConvertNumberToTimeinJobs(parseFloat(rate) + parseFloat(this._lstTempAssigneeTemp[i].rateperHour == "-" ? 0 : this._lstTempAssigneeTemp[i].rateperHour.toString().replace("$", "")));
      }
      this.totalassignedtime = Number(etime) == 0 ? "-" : etime.toString().replace(".", ":");
      this.totalcost = Number(sumcost) == 0 ? "-" : Number(sumcost).toFixed(2);
      if (this._lstTempAssigneeTemp.length == 0) {
        this.createJobTableShow = false;
      }
      for (let i = 0; i < this._lstTempAssigneeTemp.length; i++) {
        this._lstTempAssignee.push(this._lstTempAssigneeTemp[i])
      }
      for (let i = 0; i < this._lstTempAssignee.length; i++) {
        this._lstTempAssignee[i].time = this.ConverttoTimeFormatforJob(this._lstTempAssignee[i].time.toString().replace(":", "."));
        this._lstTempAssignee[i].rateperHour = this._lstTempAssignee[i].rateperHour.toString().replace("$", "");
        if (this._lstTempAssignee[i].rateperHour != "-")
          this._lstTempAssignee[i].rateperHour = this._lstTempAssignee[i].rateperHour == 0 ? "-" : this._lstTempAssignee[i].rateperHour;
      }
      this.checkDisableButton = false;
    }
  }

  onItemDeSelect(item: any) {
    if (item.userId != this.jobDataModal.partnerId && item.userId != this.jobDataModal.managerId) {
      this.TimeErrorMsg = false;
      this.DeleteAssigneeStaff(item.userId, -1);
    }
  }

  onSelectAll(items: any) {
    this._lstTempAssignee = [];
    const selectedUsers = items.map(({ userId }) => { return { UserId: userId } });
    this.jobsAssignUser.assignUserIds = JSON.stringify(selectedUsers);
    this._jobService.getAssigneeDetailsForJob(this.jobsAssignUser).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      this._lstTempAssignee = result;
      let sum: number = this._lstTempAssignee.map(a => a.rateperHour).reduce(function (a, b) {
        return a + b;
      });
      this.totalrate = sum;
    });
    this.createJobTableShow = true;
  }

  onDeSelectAll(items: any) {
    this.TimeErrorMsg = false;
    this._lstTempAssignee = [];
    this.totalassignedtime = 0;
    this.totalcost = 0;
    this.totalrate = 0;
    this.createJobTableShow = false;
  }

  CalculateTotalCost() {
    for (let i = 0; i < this._lstTempAssignee.length; i++) {
      if (this._lstTempAssignee[i].rateperHour == '' || this._lstTempAssignee[i].rateperHour == null) {
        this._lstTempAssignee[i].rateperHour = "-";
      }
    }
    let sumcost: any = "0";
    let sumtime: any = "0";
    for (let i = 0; i < this._lstTempAssignee.length; i++) {
      sumcost = parseFloat(sumcost) + parseFloat(this._lstTempAssignee[i].cost == "-" ? 0 : this._lstTempAssignee[i].cost);
      sumtime = this.CalculateTotalTimeforJob(parseFloat(sumtime), parseFloat((this._lstTempAssignee[i].time == "-" || this._lstTempAssignee[i].time == "") ? 0 : this._lstTempAssignee[i].time));
    }
    this.totalassignedtime = Number(sumtime) == 0 ? "-" : this.ConverttoTimeFormatforJob(sumtime);
    this.totalcost = Number(sumcost) == 0 ? "-" : parseFloat(sumcost).toFixed(2);
    for (let i = 0; i < this._lstTempAssignee.length; i++) {
      this._lstTempAssignee[i].time = this.ConverttoTimeFormatforJob(this._lstTempAssignee[i].time.toString().replace(":", "."));
      this._lstTempAssignee[i].rateperHour = this._lstTempAssignee[i].rateperHour.toString().replace("$", "");
      if (this._lstTempAssignee[i].rateperHour != "-")
        this._lstTempAssignee[i].rateperHour = this._lstTempAssignee[i].rateperHour == 0 ? "-" : this._lstTempAssignee[i].rateperHour;
    }
  }

  oncalcaluteTime(val) {
    let decimalTime = parseFloat(val);
    decimalTime = decimalTime * 60 * 60;
    const hours = Math.floor((decimalTime / (60 * 60)));
    decimalTime = decimalTime - (hours * 60 * 60);
    const minutes = Math.floor((decimalTime / 60));
    let hours1 = "";
    let minutes1 = "";

    if (hours < 10) {
      hours1 = "0" + hours;
    } else { hours1 = "" + hours; }

    if (minutes < 10) {
      minutes1 = "0" + minutes;
    } else { minutes1 = "" + minutes; }
    return "" + hours1 + ":" + minutes1;
  }


  CalculateCost(item: any) {
    if (item != undefined && this._lstTempAssignee.length > 0) {
      if (item.userId == undefined || item.time == "-" || item.time == "" || item.time == 0) {
        item.time = ""
      }
      else {
        if (item.time.indexOf('.') > -1) {
          let pcheck = this.oncalcaluteTime(item.time);
          item.time = Number(pcheck.replace(":", ".")).toFixed(2);
        }
        else {
          item.time = item.time.replace(":", ".")
          item.time = this.ConvertNumberToTimeforJob(parseFloat(item.time));
        }
      }

      this.TimeErrorMsg = false;
      const x = item.time.toString();
      if (item.time < 0 || item.time > 1000 || item.time == 0 || x.length > 6) {
        item.time = "";
      }
      const assignee = this._lstTempAssignee.findIndex(obj => obj.userId === item.userId);
      if (assignee > -1) {
        this._lstTempAssignee[assignee].time = item.time;
      }
      const _tempTime = (item.time == "-" || item.time == "") ? 0 : item.time;
      const _tempRate = item.rateperHour == "-" ? 0 : parseFloat(item.rateperHour.toString().replace("$", ""));
      const cost = (_tempRate) * this.ConvertTimeInOnlyHrs(_tempTime);
      item.cost = cost.toFixed(2);
      let sumtime: any = "0";
      let sumcost: any = "0";
      for (let i = 0; i < this._lstTempAssignee.length; i++) {
        sumcost = parseFloat(sumcost) + parseFloat(this._lstTempAssignee[i].cost == "-" ? 0 : this._lstTempAssignee[i].cost);
        sumtime = this.CalculateTotalTimeforJob(parseFloat(sumtime), parseFloat((this._lstTempAssignee[i].time == "-" || this._lstTempAssignee[i].time == "") ? 0 : this._lstTempAssignee[i].time.toString().replace(":", ".")));
      }
      this.totalassignedtime = Number(sumtime) == 0 ? "-" : this.ConvertNumberToTimeinJobs(sumtime).replace(".", ":");
      this.totalcost = Number(sumcost) == 0 ? "-" : sumcost.toFixed(2);
      if (this._lstTempAssignee.length > 0) {
        this.createJobTableShow = true;
      }
      for (let i = 0; i < this._lstTempAssignee.length; i++) {
        this._lstTempAssignee[i].time = this.ConverttoTimeFormatforJob(this._lstTempAssignee[i].time.toString().replace(":", "."));
        this._lstTempAssignee[i].cost = Number(this._lstTempAssignee[i].cost) == 0 ? "-" : this._lstTempAssignee[i].cost;
        this._lstTempAssignee[i].rateperHour = Number(this._lstTempAssignee[i].rateperHour) == 0 ? "-" : this._lstTempAssignee[i].rateperHour;
      }
    }
  }

  ConvertNumberToTimeinJobs(inputVal) {
    inputVal = inputVal != '' && inputVal != undefined ? Number(inputVal) : 0;
    let decimalTimeString = inputVal.toFixed(2);
    let io = decimalTimeString.split('.');
    if (Number(io[1]) > 59) {
      let c_minute = "" + (Math.floor(Number(io[1])) % 60);
      if (c_minute.length == 1) {
        c_minute = '0' + c_minute;
      }
      const temp_hours = ("" + (Math.floor(Number(io[1])) / 60)).split('.');
      const c_hours = Number(io[0]) + Number(temp_hours[0]);
      const time = Number(c_hours + "." + c_minute);
      return time;
    }
    return inputVal.toFixed(2);
  }

  eventChangeInClient(event) {
    this._lstTempAssignee = []; this.createJobTableShow = false;
    const res = this.clientCombo.filter(x => x.clientId == Number(event.clientId));
    if (res.length == 1) {
      this.clientName = res[0].clientName;
      this.enttypeId = Number(res[0].entityTypeId);
      this.GetClientProfileById(Number(event?.clientId));
      this.getJobTypes(res[0].entityTypeId);
    }
    this.getDebtorClientList(event);
  }

  getDebtorClientList(clientData: any) {
    this._clientService.GetDebtorClient(clientData?.clientId, 'debtor').pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (response) => {
        this.debtorClientList = response?.filter((client: any) => client?.clientName?.trim() !== "");
        this.isDebtorClientListAPICalled = true;
        if (clientData?.isEditJob) {
          this.setEditJobDebtorData();
        } else {
          this.setDebtorData(clientData);
        }
      },
      error: (error: any) => {
        this._toastr.error("Failed to fetch debtor client list");
      }
    });
  }

  setEditJobDebtorData() {
    const jobDebtorClientId = this.debtorClientList.find(debtorData => debtorData?.debtorClientId == this.savedJobData?.debtorClientId)?.debtorClientId;

    if (jobDebtorClientId) {
      this.jobDataModal.debtorClientId = jobDebtorClientId;
    } else {
      this.jobDataModal.debtorClientId = null;
    }
  }

  setDebtorData(clientData: any) {
    if (this.debtorClientList?.length === 1) {
      this.jobDataModal.debtorClientId = this.debtorClientList[0]?.debtorClientId;
    } else if (this.debtorClientList?.length > 1) {
      const groupDebtorId = this.debtorClientList.find(debtorData => debtorData?.debtorClientId != clientData?.clientId)?.debtorClientId;
      if (groupDebtorId) {
        this.jobDataModal.debtorClientId = groupDebtorId;
      } else {
        this.jobDataModal.debtorClientId = this.debtorClientList[0]?.debtorClientId;
      }
    } else {
      this.jobDataModal.debtorClientId = null;
    }
  }

  public _clintddFlag: any = 0;
  public isModifyTeamData: boolean;
  getFirmDetails() {
    this.firmDetailService.getFirmDetails().pipe(takeUntil(this.unsubscribe)).subscribe({ // Dev Rahul Newara CUST-8432 Date:30-10-2025
      next: (response) => {
        this.isModifyTeamData = response?.isModifyTeamInJob;
        this.officeData.canViewOffice = response?.canEnableOffice || false;
      },
      error: (error: any) => {
        this.getOfficePermissions();
      }
    });
  }

  getOfficePermissions() {
    this.getActiveOfficesList();  // Dev Rahul Newara CUST-8432 Date: 18-03-2026
  }

  /**
   * This method is used to get active office list
   */
  getActiveOfficesList() {
    this.officeService.getActiveOfficeList().pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (result) => {
        this.officeData.officeList = result;
      },
      error: (err: any) => {
        this._toastr.error("Failed to fetch office list. Please try again.");
      }
    });
  }

  clearOffice() {
    this.officeData.selectedOfficeId = null;
  }

  getClientsForCombo() {
    this._clientService.GetClientListForCombo().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result) {
        this.clientCombo = result.filter(x => !(x.status == 'Archive' || x.status == 'Lost'));

      }
      const res = this.clientCombo.filter(x => x.clientId == Number(this._clientid));
      if (this._clientid == 0) {
        this._clientid = undefined;
      }
      this.jobDataModal.clientId = this._clientid;

      if (res?.length == 1) {
        this.clientName = res[0].clientName;
        this.clientCode = res[0].clientCode;
        this.clientSearch = res[0].clientCode;
        this.enttypeId = res[0].entityTypeId;
        let _namear = this.clientName.split(" ", 3);
        if (_namear != undefined && _namear.length > 0) {
          let nam = _namear[0].replace(/\s/g, "").substring(0, 1);
          if (_namear.length > 1) {
            nam = nam + _namear[1].replace(/\s/g, "").substring(0, 1);
          }
          this.clientShortName = nam;
        } else {
          this.shortName = 'MN';
        }
        if (res[0].entityTypeId == 1) { this.clientEntityType = 'Individual'; }
        else if (res[0].entityTypeId == 2) { this.clientEntityType = 'Company'; }
        else if (res[0].entityTypeId == 3) { this.clientEntityType = 'Trust'; }
        else if (res[0].entityTypeId == 4) { this.clientEntityType = 'Partnership'; }
        else if (res[0].entityTypeId == 5) { this.clientEntityType = 'SMSF'; }
        else { this.clientEntityType = ''; }
      }
    });
  }

  getJobTypes(entityTypeId) {
    this._jobService.getJobTypeByEntityTypeId(entityTypeId).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.jobTypesL = res;
    });
  }

  getJobDivision(entityTypeId) {
    this._jobService.getJobDivisionByClientCode(entityTypeId).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (res != 0) {
        this.jobDataModal.divisionId = res;
      }
    });
  }

  getFY() {
    this.fyForSelection = [];
    const d = new Date();
    let currentYear = d.getFullYear() + 2;
    for (let i = 0; i < 12; i++) {
      this.fyForSelection.push({ value: currentYear.toString(), text: currentYear.toString() });
      currentYear--;
    }
  }

  getDivisions() {
    this.divisionManagementService.getAllActiveDivision().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result) {
        this.divisions = result;
      }
    });
  }

  getStaffs() {
    let _lst = [];
    this.users$.pipe(takeUntil(this.unsubscribe)).subscribe(users => {
      if (users) {
        users.forEach(childObj => {
          let fname = childObj.firstName + ' ' + childObj.lastName;
          _lst.push({ fullName: fname, userId: childObj.userId, roleName: childObj.roleName });
        });

        this.allUsers = users;
        this.allActiveUsers = users?.filter(user => user.inviteStatus === 'Accepted') || [];

        this.createCFUserDropdowns();

        this._jobService.getUnAssignedUser().pipe(takeUntil(this.unsubscribe)).subscribe(res => {
          if (res) {
            res.forEach(childObj => {
              _lst.push({ fullName: childObj.fullName, userId: childObj.userId, roleName: childObj.roleName });
            });

            this.users = _lst;
            this.users = this.users.filter(x => x.userId);

            this.userByRoles = this.users.reduce((acc, user) => {
              if (!acc[user.roleName]) {
                acc[user.roleName] = [];
              }
              acc[user.roleName].push(user);
              return acc;
            }, {});
          }
        });
      }
    });
  }

  getALLJobTemplate() {       // Devloper: Sasmit V; CUST-1330; Date:10-June-2022
    this._folderService.getAllJobTemplate().pipe(takeUntil(this.unsubscribe)).subscribe((result: any) => {
      if (result) {
        this.jobTemplate = result.filter(x => x.isDeactivate == true);
      }
    })
  }
  loadPeriodFrequencyJobTypeChange(jobTypeObj) {

    this.isJobRecurrence = jobTypeObj?.isJobRecurrence;
    this.statusMonthlyModel = this.statusQuarterlyModel = [];
    if (jobTypeObj?.frequency == 'Monthly') {
      this.jobselectedFrequency = 'Monthly';
      this.statusMonthlyModel = jobTypeObj?.period != "" ? this.parseJsonSafe(jobTypeObj?.period, []) : [];
    }
    else if (jobTypeObj?.frequency == 'Quarterly') {
      this.jobselectedFrequency = 'Quarterly';
      this.statusQuarterlyModel = jobTypeObj?.period != "" ? this.parseJsonSafe(jobTypeObj?.period, []) : [];
    }
    else if (jobTypeObj?.frequency == 'Yearly') {
      this.jobselectedFrequency = 'Annually';
    }
    else {
      this.jobselectedFrequency = 'None';
    }

    if (jobTypeObj?.isJobRecurrence) {
      this.recurranceData.Frequency = this.jobselectedFrequency;
      this.onChangeRecurranceFrequency();
      if (jobTypeObj?.taskCarryForward.toLowerCase() == 'from existing job'.toLowerCase()) {
        this.recurranceData.TaskCarryForward = "From this job";
      }
      else if (jobTypeObj?.taskCarryForward.toLowerCase() == 'From the template'.toLowerCase()) {
        this.recurranceData.TaskCarryForward = "From the template";
      }
      else {
        this.recurranceData.TaskCarryForward = 'None';
      }
      this.onTaskCarryForwardChange('event');


      if (jobTypeObj?.assigneeCarryForward.toLowerCase() == 'from existing job'.toLowerCase() && jobTypeObj?.taskCarryForward.toLowerCase() == 'from existing job'.toLowerCase()) {
        this.recurranceData.AssigneeCarryForward = "From this job";
      }
      else {
        this.recurranceData.AssigneeCarryForward = 'None';
      }
      this.onAssigneeCarryForwardChange('event')

      if (jobTypeObj?.budgetCarryForward.toLowerCase() == 'from existing job'.toLowerCase()) {
        this.recurranceData.BudgetCarryForward = "From this job";
      }
      else {
        this.recurranceData.BudgetCarryForward = 'None';
      }
    }
  }
  async eventChangeInJobType(event) {
    let jobCategory;

    if (!this.isEditMode) {
      const clientIdAsNumber = Number(this.jobDataModal.clientId);

      if (this.debtorClientList.find(item => item.debtorClientId === clientIdAsNumber)) {
        this.isDebtorClient = true;
      } else {
        this.isDebtorClient = false;
      }
    }

    try {
      if (this.isDebtorClient) {
        jobCategory = this.jobTypesL?.find(item => item?.jobTypeId === event)?.debtorJobCategory;
      } else {
        jobCategory = this.jobTypesL?.find(item => item?.jobTypeId === event)?.relatedJobCategory;
      }
      if (jobCategory > 0) {
        const categoryMap = [
          { bit: 4, item_id: 4, item_text: 'Disbursement' },
          { bit: 2, item_id: 2, item_text: 'Timesheet' },
          { bit: 1, item_id: 1, item_text: 'Workflow' },
        ];

        this.jobCategoryselectedItems = categoryMap
          .filter(category => jobCategory & category.bit)
          .map(category => ({ item_id: category.item_id, item_text: category.item_text }));
      }

      let jobTypeId = Number(event);
      if (event?.jobTypeId != undefined) {
        jobTypeId = Number(event?.jobTypeId);
      }


      if (this.jobTemplate?.length > 0) {
        const obj = this.jobTemplate.filter(x => x.jobTypeId == jobTypeId);
        this.jobDataModal.templateId = obj.length > 0 ? obj[0].templateId : undefined;
        if (this.jobDataModal.templateId && !this.isEditMode) {
          this.getTaskEstimates(this.jobDataModal.templateId);
          const templateTurnaround = obj[0]?.turnaround || 0;
          this.jobDataModal.turnaround = null;

          timer(500).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.jobDataModal.turnaround = templateTurnaround;
            if (this.jobDataModal.startDate) {
              this.calculateDueDateFromStartAndTurnaround();
            }
          });
        }
      }
      if (!this.isEditMode) {
        if (this.jobTypesL == undefined) {
          this.getJobTypes(this.enttypeId);

          timer(1000).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            const Jtname = this.jobTypesL?.filter(x => Number(x.jobTypeId) == jobTypeId);

            if (Jtname?.length) {
              if (!this.isEditMode) { this.loadPeriodFrequencyJobTypeChange(Jtname[0]); }
              this.jobDataModal.jobName = Jtname.length > 0 ? Jtname[0].jobTypeName : '';
              this.jobDataModal.scope = Jtname[0].description;
            }
          });
        }
        else {
          const Jtname = this.jobTypesL?.filter(x => Number(x.jobTypeId) == jobTypeId);
          if (!this.isEditMode) { this.loadPeriodFrequencyJobTypeChange(Jtname[0]); }
          this.jobDataModal.jobName = Jtname.length > 0 ? Jtname[0].jobTypeName : '';
          this.jobDataModal.scope = Jtname[0].description;
        }
      }
      if (!this.isEditMode) {
        this.getDivisionByJobTypeId(jobTypeId);
        this.recurrenceEnableChk = this.isJobRecurrence;
        this.lastTab = this.recurrenceEnableChk ? 3 : 2;
      }
      if (this.jobDataModal.scope != undefined) {
        this.maxLength = this.jobDataModal.scope.length;
      }

      let res = await firstValueFrom(this._jobService.GetJobs(this.enttypeId, jobTypeId).pipe(takeUntil(this.unsubscribe)));
      if (res) {
        let templist: any = [];
        res = res.filter(x => x.jobTypeId == jobTypeId && x.status == true);
        this.statuslist = this.groupDataByCategory(res)
        this.statusOrderList.forEach(element => {
          let filterdList = this.statuslist.filter(item => item.name == element.status);
          if (filterdList.length != 0)
            templist.push(filterdList[0]);
        })
        this.statuslist = templist;
        if (this.isEditMode == false && this.statuslist.length > 0) {
          this.jobDataModal.jobstatusId = this.statuslist[0]?.data[0]?.statusId;
        this.selectedStatus = this.statuslist[0]?.data[0]?.statusName;
      }
        if (this.isEditMode) {
          this.jobDataModal.jobstatusId = this.jobDataModal.statusId;
        }
        if (this.isEditMode) {
          this.getAllJobTaskGroupbyJobId(this.jobDataModal.jobId);
        }
      }
    }
    catch (error) {
      console.error('eventChangeInJobType' + error);
    }
  }
  async onTemplateClear() {
    this.lastTemplate = null;
    this.jobDataModal.jobEstimateType = 'Job';
    this.jobDataModal.turnaround = undefined;
    await this.onChangeEstimateType();
  }
  async resetAssignAndEstimate() {
    await this.setDefaultTaskTemplate();
  }
  onTemplateChange() {
    const selectedTemplate = this.jobTemplate.find(
      t => t.templateId === this.jobDataModal.templateId
    );

    if (!this.isEditMode && selectedTemplate) {
      const templateTurnaround = selectedTemplate.turnaround || 0;
      this.jobDataModal.turnaround = null;

      timer(500).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.jobDataModal.turnaround = templateTurnaround;

        if (this.jobDataModal.startDate && this.triggerDateCalculation) {
          this.calculateDueDateFromStartAndTurnaround();
        }
      });

      this.getTaskEstimates(this.jobDataModal.templateId);
    }
  }

  onTurnaroundChange(value: any) {
    if (this.triggerDateCalculation && this.jobDataModal.startDate && value != null) {
      this.calculateDueDateFromStartAndTurnaround();
    }
  }


  calculateDueDateFromStartAndTurnaround() {
    if (this.jobDataModal.startDate && this.jobDataModal.turnaround != null) {
      const start = (moment as any)(this.jobDataModal.startDate).startOf('day');
      const due = start.clone().add(Number(this.jobDataModal.turnaround), 'days');
      this.jobDataModal.dueDate = due.toDate();
    }
  }

  getUniqueId() {
    return crypto.randomUUID();
  };
  async bindEmptyTemplate() {
    await this.resetAssignAndEstimate();
    await this.onChangeEstimateType();
    if (this.lastTemplate) {
      this.createAssignAndEstimate(this.common.copyObject(this.lastTemplate));
      this.assignAndEstimate?.Estimate.forEach((group, index) => {
        group.taskgroupId = this.getUniqueId();
        group.sequence = index + 1;
        group.tasks.forEach(task => {
          task.templateTaskId = task.taskId;
          task.taskId = this.getUniqueId();
          task.taskgroupId = group.taskgroupId;
        })
      })
    }
  }
  getTaskEstimates(templateID: number) {
    if (!templateID) return;
    this._folderService.GetTemplateDetailWithGroups(templateID).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      this.jobDataModal.jobEstimateType = res?.template?.templateEstimateType || 'Job';
      this.lastTemplate = res.groups || [];
      this.bindEmptyTemplate();
    })
  }

  getAllJobTaskGroupbyJobId(jobId: number) {
    if (!jobId) return;
    firstValueFrom(this.taskService.GetAllJobTaskGroupbyJobId(jobId, 7).pipe(takeUntil(this.unsubscribe)))
      .then(res => {
        this.lastTemplate = res;
        this.mapAssignAndEstimate();
      })
      .catch(error => console.error('Error fetching job tasks:', error));
  }

  getAvaiableRolesForTask(task: EstimateTask, roleId: number = null) {
    const existingRolesWithoutUser = task._estimateDataListUnsaved.filter(x => x.roleId && !x.userId).map(x => x.roleId);
    return this.roles.filter(x => x.roleId === roleId || !existingRolesWithoutUser.includes(x.roleId));
  };

  getAvaiableUsersForTask(task: EstimateTask, userId: string = null) {
    const selectedUsers = task._estimateDataListUnsaved.map(x => x.userId);
    return this.getAvailableUsersForTask().filter(x => x.userId === userId || !selectedUsers.includes(x.userId));
  };

  tempJobCategory: number;
  createAssignAndEstimate(res) {
    res.forEach(x => {
      const group = x.taskGroup;

      this.assignAndEstimate.Estimate.push({
        taskgroupId: group.taskgroupId,
        sequence: group.sequence,
        taskGroupName: group.taskGroupName,
        tasks: x.data,
        _groupAssigneeOverview: [],
      });
    });

    const templateRoles: any = {};

    this.assignAndEstimate?.Estimate.forEach(estimate => {
      estimate.tasks.forEach((task) => {
        task.assignedUnit = 0;
        task._estimateDataList = this.parseJsonSafe(task.estimateData, []);
        task._estimateDataListUnsaved = this.parseJsonSafe(task.estimateData, []);

        task._estimateDataList.forEach(estimate => {
          estimate.time = this.getTimeFromUnit(estimate.unit);
          estimate.roleName = this.getRoleById(estimate.roleId)?.roleName;

          if (estimate.userId) {
            estimate.fullName = this.getUserById(estimate.userId)?.fullName || '';
            estimate.initials = this.extractInitialsFromFirstName(estimate.fullName) || '';
          }

          if (['Partner', 'Manager'].includes(estimate.roleName)) {
            this.assignAndEstimate.Assign.staff[estimate.roleName === 'Partner' ? 0 : 1].unit += estimate.unit;
          } else if (templateRoles[estimate.roleName]) {
            templateRoles[estimate.roleName].unit = estimate.unit;
          } else {
            templateRoles[estimate.roleName] = {
              roleName: estimate.roleName,
              roleId: estimate.roleId,
              unit: estimate.unit,
            };
          }
        });
        this.setFilteredListForTask(task);

        this.setTaskRoleNames(task);

        this.createUnsavedEstimatesList(task);
      });
    });

    for (const role in templateRoles) {
      this.assignAndEstimate.Assign.staff.push({
        ...new AssignedUser,
        userId: null,
        fullName: '',
        isFirstUserForRole: true,
        jobLevelRoleId: templateRoles[role].roleId,
        jobLevelRoleName: templateRoles[role].roleName,
        isJobLevelUser: false,
        unit: templateRoles[role].unit,
        time: this.getTimeFromUnit(templateRoles[role].unit),
      });
    }
    let staff = this.assignAndEstimate.Assign.staff;
    staff.forEach(user => {
      this.setAssigneeRates(user);
      user.cost = this.getUserCost(user);
    });
    this.assignAndEstimate.Assign.staff = staff;
    if (!this.jobDataModal.jobId) {

      this.assignAndEstimate.Assign.staff.forEach(assignee => {
        if (!assignee.userId) {
          assignee.fullName = 'Unassigned';
        }
        this.autoAssignPartnerManager(assignee);
      });
    }
    if (!this.isEditMode) {
      this.masterEstimateData = structuredClone(this.assignAndEstimate?.Estimate);
      this.filterTaskData(this.assignAndEstimate?.Estimate);
    } else {
      this.masterTaskList = [...this.assignAndEstimate?.Estimate];
    }
    this.setFilteredAssignUserOptions();
  }
  masterEstimateData: any;
  prevSelectedJobCategories: number = 0;
  onJobCategoryChange() {
    if (!this.isEditMode) {
      let data = structuredClone(this.masterEstimateData);
      let curSelectedJobCategories = this.jobCategoryselectedItems?.reduce((total, item) => total + item?.item_id, 0);

      if (curSelectedJobCategories !== this.prevSelectedJobCategories) {
        this.filterTaskData(data);
        this.prevSelectedJobCategories = curSelectedJobCategories;
      }
    }
  }

  filterTaskData(data) {
    let jobCategory = this.jobCategoryselectedItems?.reduce((total, item) => total + item?.item_id, 0);
    this.tempJobCategory = jobCategory;
    data?.forEach(estimate => {
      estimate.tasks = estimate?.tasks?.filter(task => {

        if (jobCategory === 1 || jobCategory === 5) {
          return task.taskCategory === 1 || task.taskCategory === 3 || task.taskCategory === 5;
        }
        if (jobCategory === 2 || jobCategory === 6) {
          return task.taskCategory === 2 || task.taskCategory === 3 || task.taskCategory === 4 || task.taskCategory === 5;
        }
        if (jobCategory === 4) {
          return false;
        }
        return true;
      });
    });

    this.assignAndEstimate.Estimate = data?.filter(estimate => estimate.tasks.length > 0);
  }

  autoAssignPartnerManager(assignee: AssignedUser) {
    if (!this.assignAndEstimate?.Estimate.length) {
      return;
    }
    const isAnyTaskForRole = this.assignAndEstimate.Estimate.find(group => group.tasks.find(task => task._estimateDataList.find(estimate => estimate.roleId === assignee.jobLevelRoleId)))
    if (isAnyTaskForRole) {
      this.onAssigneeSelectionChange({ userId: assignee.userId }, assignee);
    }
  }
  async setDefaultTaskTemplate() {
    this.assignAndEstimate = new AssignAndEstimate;
    await this.setDefaultAssignees();
  }
  async setDefaultAssignees() {
    const partner = {
      ...new AssignedUser,
      userId: this.jobDataModal.partnerId || null,
      fullName: this.allUsers.find(x => x.userId === this.jobDataModal.partnerId)?.fullName,
      isFirstUserForRole: true,
      jobLevelRoleId: this.roles.find(x => x.roleName === 'Partner')?.roleId,
      jobLevelRoleName: 'Partner',
      isJobLevelUser: true,
    }
    const partnerRates = await this.getUserRateAsPromise(partner)
    partner.userRates = partnerRates;
    partner.selectedRate = partnerRates.find(x => x.isDefault)?.ValueAmt;

    this.assignAndEstimate.Assign.staff.push(partner)
    this.autoAssignPartnerManager(partner);

    const manager = {
      ...new AssignedUser,
      fullName: this.allUsers.find(x => x.userId === this.jobDataModal.managerId)?.fullName,
      userId: this.jobDataModal.managerId || null,
      isFirstUserForRole: true,
      jobLevelRoleId: this.roles.find(x => x.roleName === 'Manager')?.roleId,
      jobLevelRoleName: 'Manager',
      isJobLevelUser: true
    }
    const managerRates = await this.getUserRateAsPromise(manager)
    manager.userRates = managerRates;
    manager.selectedRate = managerRates.find(x => x.isDefault)?.ValueAmt;

    this.assignAndEstimate.Assign.staff.push(manager)
    this.autoAssignPartnerManager(manager);
  }
  setDefaultEstimateTaskGroup() {

    this.assignAndEstimate.Estimate = [({
      taskgroupId: 1,
      sequence: 2,
      taskGroupName: 'General',
      tasks: [{
        ...new EstimateTask,
        taskId: 1,
        taskName: this.jobTypesL.find(x => x.jobTypeId === this.jobDataModal.jobTypeId)?.jobTypeName,
        _estimateDataList: [],
      }],
      _groupAssigneeOverview: [],
    })]
  }

  get totalAssignStaffTime(): string {
    const totalUnits = this.totalAssignStaffEstimate;
    return this.getTimeFromUnit(totalUnits);
  }

  get totalAssignStaffCost() {
    if (!this.assignAndEstimate.Estimate) return 0;

    const assignedCost = this.assignAndEstimate.Assign.staff.reduce((total, staff) => {
      return total + parseFloat(staff.cost);
    }, 0);
    return (assignedCost + parseInt(this.assignAndEstimate.Assign.unassigned.cost || '0'))?.toFixed(2);
  }
  get totalAssignStaffRate(): number {
    if (!this.assignAndEstimate.Estimate) return 0;
    return this.assignAndEstimate.Assign.staff.reduce((total, staff) => total + staff.selectedRate, 0);
  }

  get totalAssignStaffEstimate(): number {
    if (!this.assignAndEstimate.Estimate) return 0;
    const assignedUnits = this.assignAndEstimate.Assign.staff.reduce((total, staff) => {
      return total + staff.unit;
    }, 0);

    return assignedUnits + (this.assignAndEstimate.Assign.unassigned.unit || 0);
  }

  getUserCost(user: AssignedUser) {
    const totalMinutes = (user.unit || 0) * this.firmSetting.unitvalue;
    return (user.selectedRate * (totalMinutes / 60)).toFixed(2);
  }
  calculateCost(user: AssignedUser) {
    const totalMinutes = (user.unit || 0) * this.firmSetting.unitvalue;
    user.cost = (user.selectedRate * (totalMinutes / 60)).toFixed(2);
    this.updateTaskGroupAssigneeOverview();
  }
  addNewAssigneeRow() {
    const staff = this.assignAndEstimate.Assign.staff;
    const allSelectedIds = this.assignAndEstimate.Assign.staff.map(u => u.userId).flat();
    let newData = new AssignedUser;
    newData._availableUserOptions = this.getAvailableAssigneesForRole(newData.jobLevelRoleId);
    newData._availableRoleOptions = this.getAvailableRolesForAssignee(newData);
    const anyEmptyUser = staff.some(x => !x.userId && !x.jobLevelRoleId && !x.isJobLevelUser && !x.isFirstUserForRole);
    if (!staff.length || !anyEmptyUser) {
      staff.push(newData);
    }
  }
  async onChangeAssigneeRole(event: any, user: AssignedUser) {
    this.setFilteredAssignUserOptions();
    if (!user.userId) {
      const roleRates = this.getRoleLevelRates(user.jobLevelRoleId);
      user.userRates = roleRates;
      user.selectedRate = roleRates[0]?.ValueAmt;
      this.calculateAssigneeTimeCost(user);
    } else {
      this.onAssigneeSelectionChange({ userId: user.userId }, user)
    }

    if (user.jobLevelRoleId != user._previousRoleId) {
      if (user.userId) {
        this.assignAndEstimate?.Estimate.forEach(group => {
          group.tasks.forEach(task => {
            task._estimateDataList?.forEach(estimate => {
              if (estimate.roleId === user._previousRoleId && estimate.userId === user.userId) {
                estimate.fullName = '';
                estimate.initials = '';
                estimate.userId = '';
              }
            });
            task._estimateDataListUnsaved = this.common.copyObject(task._estimateDataList);
            task.assignedUnit = this.getTotalEstimateForTask(task);
          });
        })
        this.updateTaskGroupAssigneeOverview();
        this.setUnassignedData();
      }
      this.setFilteredAssignUserOptions();
      user.cost = 0;
      user.unit = 0;
      user.time = this.getTimeFromUnit(user.unit);
    }
    user._previousRoleId = user.jobLevelRoleId;
  }

  getAvailableAssignees() {
    const allSelectedIds = this.assignAndEstimate.Assign.staff.map(u => u.userId).flat();
    let availableOptions = this.users?.filter(u => !u.isSeparator && u.userId && !allSelectedIds.includes(u.userId)) || [];
    availableOptions = this.sortItems(availableOptions, this.teamMembers);
    return availableOptions;
  }
  getAvailableRolesForAssignee(assignee: AssignedUser) {
    if (!assignee?.userId) {
      const rolesWithoutUsers = this.assignAndEstimate.Assign.staff.filter(u => !u.userId).map(u => u.jobLevelRoleId).flat();

      return this.roles.filter(x => x.roleId === assignee.jobLevelRoleId || !rolesWithoutUsers.includes(x.roleId));
    }
    const currentAssigneeRole = this.assignAndEstimate.Assign.staff.find(x => x.userId === assignee.userId && x.jobLevelRoleId === assignee.jobLevelRoleId).jobLevelRoleId;

    const userRoles = this.assignAndEstimate.Assign.staff.filter(x => x.userId === assignee.userId)?.map(x => x.jobLevelRoleId);
    let availableOptions = this.roles?.filter(u => !userRoles.includes(u.roleId) || u.roleId === currentAssigneeRole) || [];
    return availableOptions;
  }
  getAvailableAssigneesForRole(roleId: number, userId: string = null) {
    if (!roleId) {
      return this.getAvailableAssignees();
    }
    const roleSelectedIds = this.assignAndEstimate.Assign.staff.filter(u => u.jobLevelRoleId === roleId || !u.userId).map(u => u.userId).flat();
    let availableOptions = this.users?.filter(u => !u.isSeparator && u.userId && (!roleSelectedIds.includes(u.userId) || u.userId === userId)) || [];

    if (userId) {
      const selectedUser = this.users.find(u => u.userId === userId);
      if (selectedUser && !availableOptions.some(u => u.userId === userId)) {
        availableOptions.push(selectedUser);
      }
    }
    availableOptions = this.sortItems(availableOptions, this.teamMembers);
    return availableOptions;
  }

  totalGroupUnit(index: number) {
    return this.assignAndEstimate.Estimate[index].tasks.reduce((total, task) => total + (task.unit ? parseInt(task.unit) : 0), 0);
  }

  filterUsers(roleName) {
    return this.users.filter(user => user.roleName === roleName);
  }

  groupByRoleAndSumUnit(data: any[]): AssignedUser[] {
    const assigneeData: AssignedUser[] = [];

    this.assignAndEstimate.Assign._totalUnit = 0;
    data.forEach(taskGroup => {
      taskGroup.data.forEach(({ roleId, roleName, unit }: { roleId: number; roleName: string; unit: any }) => {
        if (roleId) {

          if (!assigneeData.find(x => x.jobLevelRoleId === roleId)) {
            const newAssignee = new AssignedUser;
            assigneeData.push({
              ...newAssignee,
              jobLevelRoleId: roleId,
              jobLevelRoleName: roleName
            });
          }
          this.assignAndEstimate.Assign._totalUnit += unit;
        }
      });
    });
    return assigneeData;
  }

  getTotalEstimateForTask(estimateTask: EstimateTask) {
    let estimate_time = estimateTask._estimateDataList.reduce((total, estimate) => total + (estimate.unit ? parseInt(estimate.unit) : 0), 0);
    return estimate_time || 0;
  }
  getTotalEstimateForUser(userId: string, roleId: number) {
    let estimate_time = 0;
    if (this.jobDataModal.jobEstimateType === 'Job') {
      const assigneeUser = this.assignAndEstimate.Assign.staff.find(user => ((user.userId === userId) || (!user.userId && !userId)) && user.jobLevelRoleId === roleId);
      estimate_time = assigneeUser?.unit ?? 0;
    } else {
      this.assignAndEstimate?.Estimate.forEach(group => {
        group.tasks.forEach(task => {
          task._estimateDataList.forEach(estimate => {
            if ((estimate.userId === userId || (!userId && !estimate.userId)) && estimate.roleId === roleId) {
              estimate_time += estimate.unit ? parseInt(estimate.unit) : 0;
            }
          })
        })
      })
    };
    return estimate_time;
  }

  getTimeFromUnit(unit: any) {
    return this.convertMinutesToTime(unit * (this.firmSetting?.unitvalue || 0))
  }
  convertMinutesToTime(given_minutes) {
    let hours: any = Math.floor(given_minutes / 60);
    let minutes: any = given_minutes % 60;
    minutes = ('0' + minutes).slice(-2);
    return `${hours}:${minutes}`;
  }
  convertTimeToMinutes(give_time: number) {
    let time = give_time.toString().split('.');
    let hours = parseInt(time[0], 10);
    let minutes = parseInt(time[1], 10);
    let totalMinutes = (hours * 60) + minutes;
    return totalMinutes;
  }
  groupDataByCategory(data: any[]) {
    const groupedData: { [key: string]: any[] } = {};
    const result = [];
    for (const item of data) {
      const category = item.catagoryName;
      if (!groupedData[category]) {
        groupedData[category] = [];
      }
      groupedData[category].push(item);
    }
    Object.keys(groupedData).forEach(ele => {
      result.push({ name: ele, data: groupedData[ele] })
    })
    return result;
  }

  validatedate(sd, cd) {
    const std = new Date(sd);
    const ctd = new Date(cd);
    if (std.getFullYear() < 1951 && ctd.getFullYear() < 1951) {
      return true
    }
    else {
      return false
    }
  }

  public maxLength = 0;
  countdiscreption(str) {
    this.maxLength = str.length;
  }

  descriptionLabelChange(str) {
    if (str?.length >= 1000) {
      this.checkerrordescription = true;
    } else {
      this.checkerrordescription = false;
    }
  }

  async openJobToEdit(jobId) {
    this.isEditMode = true;
    this.getClientsForCombo();
    this.files = [];
    this.fileList = [];
    try {
      const result = await firstValueFrom(this._jobService.getJobDetails(jobId).pipe(takeUntil(this.unsubscribe)));
      if (result) {
        this.savedJobData = result;
        this.callDebtorClientList();
        this.GetCustomFieldsforQuicklinksByRoleforJob(jobId, 3)
        this.jobDataModal.statusId = result.statusId.toString();
        this.jobDataModal.jobstatusId = result.statusId == 0 ? "undefined" : result.statusId;
        this.enttypeId = result.entityType;
        this.getJobTypes(this.enttypeId);
        this.eventChangeInJobType(result?.jobTypeId);
        result.startDate = result.startDate == "0001-01-01T00:00:00" ? undefined : new Date(result.startDate);
        result.dueDate = result?.dueDate == "0001-01-01T00:00:00" ? undefined : new Date(result?.dueDate);
        this.officeData.selectedOfficeId = result?.officeId || null;
        this.jobDataModal.startDate = result.startDate;
        this.jobDataModal.turnaround = null;

        timer(500).pipe(takeUntil(this.unsubscribe)).subscribe(() => { this.jobDataModal.turnaround = result?.turnaround ?? null; });

        this.jobDataModal.billingMethod = (result.billingMethod == true) ? true : false;
        this.isFixedJob = this.jobDataModal?.billingMethod == true;
        this.selectedItems = this.parseJsonSafe(result?.assignUserIds, []);
        this.jobDataModal.clientId = result.clientId;
        this.jobDataModal = result;
        if (!this.jobDataModal.priority || Number(this.jobDataModal.priority) === 0) {
          this.jobDataModal.priority = null;
        }
        this._tdiv = Number(result?.divisionId);
        this.jobDataModal.financialYear = result.financialYear;
        this.jobDataModal.divisionId = this._tdiv;
        this.jobDataModal.templateId = this.jobDataModal?.templateId == 0 ? undefined : this.jobDataModal?.templateId;
        this.jobDataModal.managerId = this.jobDataModal?.managerId == "null" ? undefined : this.jobDataModal?.managerId;
        this.jobDataModal.quote = this.jobDataModal?.quote == 0 ? "" : this.CheckQoute(this.jobDataModal?.quote);
        this.lastselectedmanager = this.jobDataModal?.managerId;
        this.lastselectedpartner = this.jobDataModal?.partnerId;

        this.recurrenceEnableChk = result.jsonJobRecurrence ? true : false;
        if (this.recurrenceEnableChk) {
          const recurrance: any = this.parseJsonSafe<any[]>(result?.jsonJobRecurrence, [{}])[0] || {};
          if (recurrance?.PeriodForDisplay) {
            const periodData = this.getReccurancePeriod(recurrance);
            this.recurranceData = {
              FY: recurrance?.FinancialYear || '',
              Frequency: recurrance?.Frequency,
              PeriodForDisplay: recurrance?.PeriodForDisplay || null,
              Period: periodData,
              Start_ReccDate: recurrance?.StartRecurrencetDate ? new Date(recurrance.StartRecurrencetDate) : null,
              Stop_ReccDate: recurrance.NextRecurrenceDate ? new Date(recurrance.NextRecurrenceDate) : null,
              TaskCarryForward: recurrance?.TaskCarryForward || 'None',
              AssigneeCarryForward: recurrance?.AssigneeCarryForward || 'None',
              BudgetCarryForward: recurrance?.BudgetForward || 'None',
              CustomPeriod: null
            }
          }
        } else {
          this.jobselectedFrequency = result?.frequency || 'None';
          this.setFrequencyPeriodData(result);
        }

        this.validatePartnersAndManagerList();

        this._jobService.GetAllJobTaskAssigneeforjobEdit(jobId).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
          if (res) {
            if (res?.lstJobAssigneeDetails.length > 0) {
              this.jobAssgineeDetails = res.lstJobAssigneeDetails;
              this.jobTaskAssgineeDetails = res.lstTaskAssigneeDetails;
              this.mapAssignAndEstimate();

              if (result.jobCategory > 0) {
                const selected: any[] = [];
                if (result.jobCategory & 4) {
                  selected.push({ item_id: 4, item_text: 'Disbursement' });
                }
                if (result.jobCategory & 2) {
                  selected.push({ item_id: 2, item_text: 'Timesheet' });
                }
                if (result.jobCategory & 1) {
                  selected.push({ item_id: 1, item_text: 'Workflow' });
                }
                this.jobCategoryselectedItems = selected;
              }

              this._lstTempAssignee = res.lstJobAssigneeDetails;
              this.totalassignedtime = res.lstJobAssigneeDetails[0]?.totalTime;
              this.totalcost = res.lstJobAssigneeDetails[0]?.totalCost;
              this.totalrate = res.lstJobAssigneeDetails[0]?.totalRate;
              this.selectedItems = this.parseJsonSafe(res.lstJobAssigneeDetails[0]?.assigneeUserId, []);
              if (this._lstTempAssignee.length > 0) {
                this.createJobTableShow = true;
                let sumtime: any = "0";
                let sumcost: any = "0";
                for (let i = 0; i < this._lstTempAssignee.length; i++) {
                  sumcost = parseFloat(sumcost) + parseFloat(this._lstTempAssignee[i]?.cost == "-" ? 0 : this._lstTempAssignee[i]?.cost);
                  sumtime = this.CalculateTotalTimeforJob(parseFloat(sumtime), parseFloat((this._lstTempAssignee[i]?.time == "-" || this._lstTempAssignee[i]?.time == "") ? 0 : this._lstTempAssignee[i]?.time?.toString()?.replace(":", ".")));
                }
                this.totalassignedtime = Number(sumtime) == 0 ? "-" : this.ConvertNumberToTimeinJobs(sumtime)?.replace(".", ":");
                this.totalcost = Number(sumcost) == 0 ? "-" : sumcost?.toFixed(2);
                if (this._lstTempAssignee.length > 0) {
                  this.createJobTableShow = true;
                }
                for (let i = 0; i < this._lstTempAssignee.length; i++) {
                  this._lstTempAssignee[i].time = this.ConverttoTimeFormatforJob(this._lstTempAssignee[i]?.time?.toString()?.replace(":", "."));
                  this._lstTempAssignee[i].cost = Number(this._lstTempAssignee[i]?.cost) == 0 ? "-" : this._lstTempAssignee[i]?.cost;
                  this._lstTempAssignee[i].rateperHour = Number(this._lstTempAssignee[i]?.rateperHour) == 0 ? "-" : this._lstTempAssignee[i]?.rateperHour;
                  this._lstTempAssignee[i]._billrateId = res?.lstJobAssigneeDetails[i]?.billRateId;
                  this._lstTempAssignee[i].multiBillrates = (res?.lstJobAssigneeDetails[i]?.multiBillrates || []).map((i) => { i.getLabel = this.currencyPipe.transform(i?.billrate); return i; });
                }
              }
            }
            this.jobDataModal.divisionId = this._tdiv;
          }

          if (this.jobDataModal?.partnerId != undefined &&
            this.jobDataModal?.partnerId != null && this.jobDataModal?.partnerId != ''
            && (this._lstTempAssignee?.filter(f => f?.userId == this.jobDataModal?.partnerId))?.length == 0) {
            this.AddAssigneeStaff(this.jobDataModal?.partnerId, -1, 1);
          }
        });
        this.jobDataModal.statusOwnerId =
          result.statusOwnerId == null ? 0 : result.statusOwnerId;

        // Re-validate owner list now that statusOwnerId is available
        this.validateOwnerList();
      }
    } catch (error) {
      console.error('Error fetching job detail:', error);
    }

    timer(2200).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.jobDataModal.divisionId = this._tdiv;
    });
  }

  getReccurancePeriod(recurrance: any) {
    const frequency = recurrance?.Frequency;
    let periodData = null;

    if (frequency && frequency == 'Monthly') {
      const selectedMonthlyPeriodData = this.frequencyMonthList.filter(period => period.item_text.includes(recurrance?.PeriodForDisplay));
      periodData = selectedMonthlyPeriodData?.length ? selectedMonthlyPeriodData : null;
    } else if (frequency && frequency == 'Quarterly') {
      const selectedQuarterPeriodData = this.frequencyQuarterList.filter(period => period.item_text.includes(recurrance?.PeriodForDisplay));
      periodData = selectedQuarterPeriodData?.length ? selectedQuarterPeriodData : null;
    } else {
      // Please handle the else case if needed.
    }
    return periodData;
  }

  setFrequencyPeriodData(result: any) {
    if (result && result?.frequency && result?.frequency !== 'None') {
      const isQuarterly = result?.frequency === 'Quarterly';
      if (isQuarterly) {
        const selectedQuarterPeriodData = this.frequencyQuarterList.filter(period => period.item_text.includes(result?.period));
        this.statusQuarterlyModel = selectedQuarterPeriodData?.length ? selectedQuarterPeriodData : null;
      } else {
        const selectedMonthlyPeriodData = this.frequencyMonthList.filter(period => period.item_text.includes(result?.period));
        this.statusMonthlyModel = selectedMonthlyPeriodData?.length ? selectedMonthlyPeriodData : null;
      }
    } else {
      // Please handle the else case if needed.
    }
  }

  callDebtorClientList() {
    if (!this.isDebtorClientListAPICalled) {
      const clientData = { clientId: this.savedJobData?.clientId, isEditJob: true };
      this.getDebtorClientList(clientData);
    }
  }

  GetPeriodDetailForFirm() {
    this._jobService.GetPeriodDetailForFirm().pipe(takeUntil(this.unsubscribe)).subscribe((result: any) => {
      if (result) {
        this.periodDetailForFirm = result;
      }
    })
  }

  frequencyValCalculation() {
    let fy = 0;
    let jobdatedetail: any[] = [];

    if (this.jobDataModal.financialYear) {
      fy = Number(this.jobDataModal.financialYear.slice(0, 4));
    }

    const monthYearMapping: Record<string, number> = {
      'January': fy + 1,
      'February': fy + 1,
      'March': fy + 1,
      'April': fy + 1,
      'May': fy + 1,
      'June': fy + 1,
      'July': fy,
      'August': fy,
      'September': fy,
      'October': fy,
      'November': fy,
      'December': fy
    };

    const quarterYearMapping: Record<string, number> = {
      'Q1': fy,
      'Q2': fy,
      'Q3': fy + 1,
      'Q4': fy + 1
    };

    if (this.jobselectedFrequency === 'Monthly') {
      this.statusMonthlyModel.forEach((childObj) => {
        const month = childObj.item_text;
        const year = monthYearMapping[month];
        if (year !== undefined) {
          const _tempobj = this.periodDetailForFirm.filter(m => m.name === month);
          if (_tempobj.length > 0) {
            jobdatedetail.push({
              Name: month,
              StartDate: `${_tempobj[0].startDate}-${year}`,
              DueDate: `${_tempobj[0].dueDate}-${year}`,
              Sequence: _tempobj[0].sequence
            });
          }
        }
      });
    } else if (this.jobselectedFrequency === 'Quarterly') {
      this.statusQuarterlyModel.forEach((childObj) => {
        const quarter = Object.keys(quarterYearMapping).find(q => childObj.item_text.includes(q));
        if (quarter) {
          const year = quarterYearMapping[quarter];
          const _tempobj = this.periodDetailForFirm.filter(m => m.name === quarter);
          if (_tempobj.length > 0) {
            jobdatedetail.push({
              Name: childObj.item_text,
              StartDate: `${_tempobj[0].startDate}-${year}`,
              DueDate: `${_tempobj[0].dueDate}-${year}`,
              Sequence: _tempobj[0].sequence
            });
          }
        }
      });
    } else {
      this.clearFreqVal();
    }

    return jobdatedetail.sort((a, b) => (a?.Sequence > b?.Sequence ? 1 : -1));
  }

  public isCarryForword: boolean = false;
  onAssigneeCarryForwardChange(event) {
    if (this.recurranceData.TaskCarryForward.toLowerCase() == 'From this job'.toLowerCase()) {
      if (this.recurranceData.AssigneeCarryForward.toLowerCase() == 'None'.toLowerCase()) {
        this.carryFwdBudgetOption = [
          { id: 0, value: 'None' },
        ];
      }
      else {
        this.carryFwdBudgetOption = [
          { id: 0, value: 'None' },
          { id: 3, value: 'From this job' },
        ];
      }
    }
  }
  onTaskCarryForwardChange(event) {
    this.recurranceData.AssigneeCarryForward = this.recurranceData.BudgetCarryForward = undefined;
    if (this.recurranceData.TaskCarryForward.toLowerCase() == 'Inherited'.toLowerCase()) {
      this.carryFwdAssigneeOption = [
        { id: 0, value: 'None' },
        { id: 1, value: 'Inherited' },
      ];
      this.carryFwdBudgetOption = [
        { id: 0, value: 'None' },
        { id: 1, value: 'Inherited' },
      ];
    }
    else if (this.recurranceData.TaskCarryForward.toLowerCase() == 'From this job'.toLowerCase()) {
      this.carryFwdAssigneeOption = [
        { id: 0, value: 'None' },
        { id: 2, value: 'From this job' }
      ];
      this.carryFwdBudgetOption = [
        { id: 0, value: 'None' },

        { id: 3, value: 'From this job' },
      ];
    }
    else if (this.recurranceData.TaskCarryForward.toLowerCase() == 'None'.toLowerCase()) {
      this.carryFwdAssigneeOption = [
        { id: 0, value: 'None' },
      ];
      this.carryFwdBudgetOption = [
        { id: 0, value: 'None' },
      ];
    }
    else if (this.recurranceData.TaskCarryForward.toLowerCase() == 'From the template'.toLowerCase()) {
      this.isCarryForword = true;
      this.carryFwdBudgetOption = [
        { id: 0, value: 'None' },

      ];

    }
    else {
      this.carryFwdAssigneeOption = [
        { id: 0, value: 'None' },
        { id: 1, value: 'Inherited' },
        { id: 2, value: 'From this job' }
      ];
      this.carryFwdBudgetOption = [
        { id: 0, value: 'None' },
        { id: 1, value: 'Inherited' },

        { id: 3, value: 'From this job' },
      ];
    }

    if (this.recurranceData.TaskCarryForward.toLowerCase() == 'From the template'.toLowerCase()) {
      this.isCarryForword = true;
      this.recurranceData.AssigneeCarryForward = this.recurranceData.BudgetCarryForward = undefined;

    } else { this.isCarryForword = false; }

  }

  clearFreqVal() {
    this.statusQuarterlyModel = this.statusMonthlyModel = []; this.jobselectedFrequency = 'None';
  }

  public statusQuarterlyModel: any;
  public statusMonthlyModel: any;

  public _tdiv: any = 0;
  validationStates: boolean[] = [];
  formSubmitted: boolean = false;
  isCancel: boolean = false;
  _customFieldDelete: any = [];
  removeJobCustomField(_customFieldDelete) {
    this._jobService.RemoveCustomField(_customFieldDelete).pipe(takeUntil(this.unsubscribe)).subscribe(response => {
      if (response.success) {
        this._customFieldDelete = [];
      }
    }, error => { this._toastr.error('Something went wrong,please try again', 'Workflow') });
  }
  addJobdetails(clientJobForm: NgForm) {
    if (this.isCancel) {
      this.isCancel = false;
      return;
    }
    this._customFieldDelete = [];
    this.formSubmitted = true;
    this.checkDisableButton = true;
    this.checkvalidation = true;
    let isFormValid = true;
    let isRecurrenceValid = true;
    this.validationStates = [];
    if (this.jobselectedFrequency === 'None' && !this.recurrenceEnableChk) {
      this.recurranceData.Frequency = '';
    }
    if (this.recurranceData.Frequency === 'Monthly') {
      isRecurrenceValid = this.validateMonthlyRecurrence();
    }

    if (this.recurranceData.Frequency === 'Quarterly') {
      isRecurrenceValid = this.validateQuarterlyRecurrence();
    }
    if (this.recurrenceEnableChk && this.recurranceData.Frequency === 'Annually') {
      isRecurrenceValid = this.validateAnnuallyRecurrence();
    }
    if (!isRecurrenceValid) {
      this._toastr.error('Please enter the number days to due.', 'Validation Error');
      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector("form .ng-invalid");
      if (firstInvalidControl) {
        firstInvalidControl.focus();
      }
      return;
    }
    if (!isFormValid || clientJobForm.form.invalid) {
      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector("form .ng-invalid");
      firstInvalidControl.focus();
      return;
    }
    if (localStorage.getItem('token') == null) { this._toastr.error("Your session has expired"); this.router.navigate(['/']); }
    this.jobDataModal.jobId = this.isEditMode ? Number(this.jobDataModal.jobId) : 0;
    let cfdata = [];
    for (let i in this.cfqjobitem) {
      if (this.cfqjobitem[i].fieldType == 'Date' && this.cfqjobitem[i].value != 'Invalid Date' && this.cfqjobitem[i].value != null) {
        this.cfqjobitem[i].value = this.datepipe.transform(this.cfqjobitem[i].value, 'MM/dd/yyyy');
      }
      else if (this.isEditMode && this.cfqjobitem[i].fieldType == 'Date' && this.cfqjobitem[i].value == null) {
        this._customFieldDelete.push({ jobId: this.jobDataModal.jobId, id: this.cfqjobitem[i].id, value: 'No value' });
      }
      if (this.cfqjobitem[i].fieldType == 'Number' && this.cfqjobitem[i].value != '' && this.cfqjobitem[i].value != null)
        this.cfqjobitem[i].value = this.cfqjobitem[i].value.toString();
      if (this.cfqjobitem[i].fieldType == 'Checkbox')
        this.cfqjobitem[i].value = this.cfqjobitem[i].customFieldValues;
      if (this.cfqjobitem[i].fieldType == 'User' && this.cfqjobitem[i]?.value)
        this.cfqjobitem[i].value = this.cfqjobitem[i]?.value?.map(x => x.id).toString();
      if (this.cfqjobitem[i].fieldType == 'Dropdown List')
        this.cfqjobitem[i].value = this.cfqjobitem[i]?.value?.toString() ?? '0';
      if (this.cfqjobitem[i].value != null) {
        if (this.cfqjobitem[i].value.length > 0 || (this.isEditMode && this.cfqjobitem[i].fieldType == 'User'))
          cfdata.push({ Id: this.cfqjobitem[i].id, value: this.cfqjobitem[i].value })
      }
    }
    if (cfdata.length > 0)
      this.jobDataModal.customfieldsData = JSON.stringify(cfdata);
    if (this.jobDataModal.financialYear == "" || this.jobDataModal.financialYear == undefined || this.jobDataModal.financialYear == 'undefined') {
      this.checkDisableButton = false;
      return;
    }
    const std = new Date(this.jobDataModal.startDate)
    const ctd = new Date(this.jobDataModal.dueDate)
    if (std.getFullYear() < 1951) {
      this._toastr.warning('invalid  startDate', 'Create Job');
      this.checkDisableButton = false;
      return;
    }
    else if (ctd.getFullYear() < 1951) {
      this._toastr.warning('invalid  DueDate', 'Create Job');
      this.checkDisableButton = false;
      return;
    }
    this._lstTempAssigneeTemp = this._lstTempAssignee;
    this.tempassignee = this._lstTempAssigneeTemp;
    this.jobDataModal.clientId = Number(this.jobDataModal.clientId);
    this.jobDataModal.jobTypeId = Number(this.jobDataModal.jobTypeId);
    this.jobDataModal.divisionId = Number(this.jobDataModal.divisionId);
    this.jobDataModal.teamId = (this.jobDataModal.teamId == null || this.jobDataModal.teamId == "" || this.jobDataModal.teamId == undefined) ? null : this.jobDataModal.teamId;
    this.jobDataModal.billingMethod = (this.jobDataModal.billingMethod == true || this.jobDataModal.billingMethod == 'true') ? true : false;
    this.jobDataModal.quote = (this.jobDataModal.quote == null || this.jobDataModal.quote == "") ? 0 : Number(this.jobDataModal.quote.toString().replaceAll(',', ''));
    this.jobDataModal.estimatedHours = (this.jobDataModal.estimatedHours == null || this.jobDataModal.estimatedHours == "") ? 0 : Number(this.jobDataModal.estimatedHours);
    this.jobDataModal.scope = (this.jobDataModal.scope == null || this.jobDataModal.scope == "" || this.jobDataModal.scope == undefined) ? null : this.jobDataModal.scope;
    this.jobDataModal.managerId = (this.jobDataModal.managerId == null || this.jobDataModal.managerId == "" || this.jobDataModal.managerId == undefined) ? null : this.jobDataModal.managerId;
    this.jobDataModal.statusId = (this.jobDataModal.jobstatusId == "undefined" || this.jobDataModal.jobstatusId == undefined) ? 0 : Number(this.jobDataModal.jobstatusId);
    this.jobDataModal.clientId = (this.jobDataModal.clientId == "undefined" || this.jobDataModal.clientId == undefined) ? 0 : Number(this.jobDataModal.clientId);
    this.jobDataModal.templateId = (this.jobDataModal.templateId == "undefined" || this.jobDataModal.templateId == undefined) ? 0 : Number(this.jobDataModal.templateId);
    let formData = new FormData();
    if (this.files.length > 1) {
      for (let x = 0; x < this.files.length; x++) {
        formData.append('files', this.files[x], this.files[x].name);
      }
    } else {
      formData.append('files', this.files[0]);
    }
    const assignUserForTask: UserEstimateRequest[] = [];
    const staffData = this.assignAndEstimate?.Assign?.staff;
    (this.assignAndEstimate?.Estimate || []).forEach(group => {
      (group?.tasks || []).forEach(task => {
        (task?._estimateDataList || []).forEach(estimate => {
          const assigneeData = (staffData || []).find(staff =>
            ((staff.userId === estimate.userId) || (!staff.userId && !estimate.userId))
            && staff.jobLevelRoleId === estimate.roleId
          );

          const selectedRate = assigneeData?.selectedRate || 0;
          const totalMinutes = parseInt(estimate.unit || '0', 10) * (this.firmSetting?.unitvalue || 0);

          const userEstimateRequest: UserEstimateRequest = {
            taskid: task.taskId,
            taskgroupid: task.taskgroupId,
            userid: estimate.userId || null,
            time: this.getTimeFromUnit(estimate.unit || '0').replace(':', '.'),
            cost: selectedRate * (totalMinutes / 60),
            unit: estimate.unit || '0',
            rate: selectedRate,
            jobLevelRoleId: estimate.roleId,
            isFirstUserForRole: assigneeData?.isFirstUserForRole ? 1 : 0
          };

          assignUserForTask.push(userEstimateRequest);
        });
      });
    });

    const _tempLstAssignee = [];
    this.assignAndEstimate?.Assign?.staff.forEach(user => {
      const assigneeData = staffData.find(staff => staff.userId === user.userId);
      const totalMinutes = parseInt(user.unit) * this.firmSetting.unitvalue;
      if (user.jobLevelRoleId) {
        if (user.userId) {
          let existingAssignee = _tempLstAssignee.find(x => x.userId === user.userId);
          if (existingAssignee) {
            existingAssignee.unit += user.unit;
            existingAssignee.cost += (user.selectedRate * (totalMinutes / 60));
            existingAssignee.time = this.getTimeFromUnit(existingAssignee.unit).replace(':', '.');
          } else {
            const defaultRate = assigneeData?.userRates.find(x => x.isDefault)?.ValueAmt || 0;
            const userRole = this.allUsers.find(x => x.userId === user.userId).roleName;
            const assignee_data = {
              userId: user.userId,
              role: userRole,
              name: user.fullName,
              rateperHour: defaultRate,
              time: this.getTimeFromUnit(user.unit).replace(':', '.'),
              cost: user.selectedRate * (totalMinutes / 60),
              unit: user.unit,
              isManagerPartner: ['Partner', 'Manager'].includes(userRole) ? 1 : 0,
            };
            _tempLstAssignee.push(assignee_data);
          }
        }
        if (this.jobDataModal.jobEstimateType === 'Job') {
          const selectedRate = user?.selectedRate || 0;
          const jobLevelAssigneeData: UserEstimateRequest = {
            taskid: null,
            taskgroupid: null,
            userid: user.userId,
            time: this.getTimeFromUnit(user.unit).replace(':', '.'),
            cost: selectedRate * (totalMinutes / 60),
            unit: user.unit || null,
            rate: selectedRate,
            jobLevelRoleId: user.jobLevelRoleId,
            isFirstUserForRole: user.isFirstUserForRole ? 1 : 0
          };
          assignUserForTask.push(jobLevelAssigneeData);
        } else {
          const existing_estimate_index = assignUserForTask.findIndex(x => ((x.userid === user.userId) || (!x.userid && !user.userId)) && x.jobLevelRoleId === user.jobLevelRoleId);
          const selectedRate = assigneeData?.selectedRate || 0;
          if (existing_estimate_index === -1) {
            const assigneeWithoutTask: UserEstimateRequest = {
              taskid: null,
              taskgroupid: null,
              userid: user.userId,
              time: 0,
              cost: selectedRate * (totalMinutes / 60),
              unit: 0,
              rate: selectedRate,
              jobLevelRoleId: user.jobLevelRoleId,
              isFirstUserForRole: user.isFirstUserForRole ? 1 : 0
            };
            assignUserForTask.push(assigneeWithoutTask);
          }
        }
      }
    })
    this.jobDataModal.assignUserIds = JSON.stringify(_tempLstAssignee);
    let sdate = this.formatDate(this.jobDataModal.startDate, 'StartDate');
    let ddate = this.formatDate(this.jobDataModal.dueDate, 'DueDate');
    formData.append('jobId', this.jobDataModal.jobId.toString());
    formData.append('jobTypeId', this.jobDataModal.jobTypeId);
    formData.append('clientId', this.jobDataModal.clientId);
    formData.append('jobName', this.jobDataModal.jobName);
    formData.append('financialYear', this.jobDataModal.financialYear);
    formData.append('statusId', this.jobDataModal.statusId);
    formData.append('scope', this.jobDataModal.scope);
    formData.append('divisionId', this.jobDataModal.divisionId);
    formData.append('partnerId', this.jobDataModal.partnerId);
    formData.append('managerId', this.jobDataModal.managerId);
    formData.append('teamId', this.jobDataModal.teamId == null ? 0 : this.jobDataModal.teamId);
    formData.append('billingMethod', this.jobDataModal.billingMethod);
    formData.append('quote', this.jobDataModal.quote);
    formData.append('estimatedHours', this.jobDataModal.estimatedHours);
    formData.append('turnaround', this.jobDataModal.turnaround?.toString() || '0');
    formData.append('startDate', sdate);
    formData.append('dueDate', ddate);
    formData.append('customfieldsData', this.jobDataModal.customfieldsData);
    formData.append('assignUserIds', this.jobDataModal.assignUserIds);
    if (!this.isEditMode) {
      this.syncEstimateWithMaster(this.masterEstimateData, this.assignAndEstimate.Estimate);
    }
    let taskTemplateJson = [];
    (this.assignAndEstimate?.Estimate || []).forEach(group => {
      taskTemplateJson.push({
        taskGroupId: group.taskgroupId,
        taskGroupName: group.taskGroupName,
        sequence: group.sequence,
        tasks: (group.tasks || []).map(task => ({
          templateTaskId: task.templateTaskId,
          taskId: task.taskId,
          taskName: task.taskName,
          taskTypeId: task.taskTypeId,
          taskCategory: task.taskCategory,
          startAfterDays: task.startAfterDays,
          dueAfterDays: task.dueAfterDays,
          sequence: task.sequence,
          estimates: (task._estimateDataList || []).map(estimate => ({
            roleId: estimate.roleId,
            unit: estimate.unit,
            time: this.getTimeFromUnit(estimate.unit || '0').replace(':', '.')
          }))
        }))
      });
    });

    taskTemplateJson = taskTemplateJson.map(group => ({
      ...group,
      tasks: group.tasks.filter(task => typeof task.taskId === 'string')
    }));
    formData.append('templateId', this.jobDataModal.templateId);
    formData.append('statusOwnerId', this.jobDataModal.statusOwnerId === 0 ? '' : this.jobDataModal.statusOwnerId);
    formData.append('jobEstimateType', this.jobDataModal.jobEstimateType);
    formData.append('assignUserForTask', JSON.stringify(assignUserForTask));
    formData.append('taskTemplateJson', JSON.stringify(taskTemplateJson));
    formData.append('priority', this.jobDataModal.priority == undefined ? '0' : this.jobDataModal.priority);
    if (!this.isEditMode && this.jobselectedFrequency != 'None') {
      let jobdatedetail = this.frequencyValCalculation();
      if (jobdatedetail != undefined && jobdatedetail.length > 0) {
        formData.append('jobdatedetail', JSON.stringify(jobdatedetail));
        formData.append('jobselectedFrequency', this.jobselectedFrequency);
      }
      else {
        formData.append('jobdatedetail', '');
        formData.append('jobselectedFrequency', 'None');
      }
    }
    else {
      formData.append('jobdatedetail', '');
      formData.append('jobselectedFrequency', 'None');
    }

    if (!this.isEditMode && this.recurrenceEnableChk) {
      const recurranceRequest: RecurranceRequest = this.common.copyObject(this.recurranceData);

      if (new Date(recurranceRequest.Start_ReccDate).getFullYear() < 1951) {
        this._toastr.warning('invalid recurrance start date', 'Create Job');
        this.checkDisableButton = false;
        return;
      } else if (new Date(recurranceRequest.Stop_ReccDate).getFullYear() < 1951) {
        this._toastr.warning('invalid recurrance stop date', 'Create Job');
        this.checkDisableButton = false;
        return;
      }
      recurranceRequest.Start_ReccDate = this.datepipe.transform(recurranceRequest.Start_ReccDate, 'yyyy-MM-dd');
      recurranceRequest.Stop_ReccDate = this.datepipe.transform(recurranceRequest.Stop_ReccDate, 'yyyy-MM-dd');

      recurranceRequest.Period = recurranceRequest.Period.map((x: any) => {
        return {
          JobId: 0,
          NewJobId: 0,
          PeriodVal: this.recurranceData.Frequency === 'Annually' ? 'Annually' : x.item_text,
          IsRecurrenceCreated: false,
        }
      });
      if (this.recurranceData.Frequency === 'Annually') {
        recurranceRequest.PeriodForDisplay = 'Annually';
      } else {
        recurranceRequest.PeriodForDisplay = recurranceRequest.Period.map((x: any) => x.PeriodVal).toString()
      }
      if (this.recurranceData.Frequency === 'Monthly') {
        recurranceRequest.CustomPeriod = this.mapRecurrenceData(this.datas);
      }
      else if (this.recurranceData.Frequency === 'Quarterly') {
        recurranceRequest.CustomPeriod = this.mapRecurrenceData(this.quarterDatas, true);
      }
      else if (this.recurranceData.Frequency === 'Annually') {
        recurranceRequest.CustomPeriod = this.mapRecurrenceData(this.annualDatas);

      }

      formData.append('jsonJobRecurrence', JSON.stringify(recurranceRequest));
    }

    if (!this.isEditMode && this.recurranceData.Frequency !== 'None') {
      const frequencyRequest: FrequencyRequest = this.common.copyObject(this.recurranceData);

      if (new Date(frequencyRequest.Start_ReccDate).getFullYear() < 1951) {
        this._toastr.warning('invalid recurrance start date', 'Create Job');
        this.checkDisableButton = false;
        return;
      } else if (new Date(frequencyRequest.Stop_ReccDate).getFullYear() < 1951) {
        this._toastr.warning('invalid recurrance stop date', 'Create Job');
        this.checkDisableButton = false;
        return;
      }
      frequencyRequest.Start_ReccDate = this.datepipe.transform(frequencyRequest.Start_ReccDate, 'yyyy-MM-dd');
      frequencyRequest.Stop_ReccDate = this.datepipe.transform(frequencyRequest.Stop_ReccDate, 'yyyy-MM-dd');

      frequencyRequest.Period = frequencyRequest.Period.map((x: any) => {
        return {
          JobId: 0,
          NewJobId: 0,
          PeriodVal: this.recurranceData.Frequency === 'Annually' ? 'Annually' : x.item_text,
          IsRecurrenceCreated: false,
        }
      });
      if (this.recurranceData.Frequency === 'Annually') {
        frequencyRequest.PeriodForDisplay = 'Annually';
      } else {
        frequencyRequest.PeriodForDisplay = frequencyRequest.Period.map((x: any) => x.PeriodVal).toString()
      }
      if (this.recurranceData.Frequency === 'Monthly') {
        frequencyRequest.CustomPeriod = this.mapRecurrenceData(this.datas);
      }
      else if (this.recurranceData.Frequency === 'Quarterly') {
        frequencyRequest.CustomPeriod = this.mapRecurrenceData(this.quarterDatas, true);
      }
      else if (this.recurranceData.Frequency === 'Annually') {
        frequencyRequest.CustomPeriod = this.mapRecurrenceData(this.annualDatas);

      }

      formData.append('jsonJobFrequency', JSON.stringify(frequencyRequest));
    }

    this.jobDataModal.jobCategory = this.jobCategoryselectedItems.reduce((total, item) => total + item.item_id, 0);
    formData.append('jobCategory', this.jobDataModal.jobCategory as any);
    formData.append('debtorClientId', this.jobDataModal.debtorClientId || null);
    formData.append('officeId', this.officeData.selectedOfficeId || '');

    this._jobService.addEditJob(formData)
      .pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (result: any) => {
          this.modalService.hide();

          const AccountFirmId = localStorage.getItem("AccountFirmId");
          if (this._customFieldDelete.length > 0) {
            this.removeJobCustomField(this._customFieldDelete);
          }
          let strMsgHeader = this.isEditMode ? 'updated successfully' : 'created successfully';
          if (result && result?.methodResponse?.jobId > 0) {
            let successMsg = result?.methodResponse?.message?.split("#");

            let jobCategory = {};

            if (!this.isEditMode) {
              if (!result.methodResponse.isMultiplejobs) {
                jobCategory = {
                  'Name': result.methodResponse.jobCode,
                  'Description': result.methodResponse.jobCode,
                  'ClientId': this.jobDataModal.clientId,
                  'ClientName': this.clientName,
                  'clientDisplay': `${this.clientCode} (${this.clientName})`,
                  'AccountingFirmId': AccountFirmId,
                  'JobId': result.methodResponse.jobId,
                  'FinancialYear': this.jobDataModal.financialYear
                };
                this.categoryService.CategoryCreateJob(jobCategory).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
                });
              } else {
                successMsg = '';
                result.methodResponse.listofjobcode.forEach((jobObj) => {
                  let njobcode = jobObj.jobCode;
                  jobCategory = {
                    'Name': jobObj.jobCode,
                    'Description': jobObj.jobCode,
                    'ClientId': this.jobDataModal.clientId,
                    'ClientName': this.clientName,
                    'AccountingFirmId': AccountFirmId,
                    'JobId': jobObj.jobId,
                    'FinancialYear': this.jobDataModal.financialYear
                  };

                  this.categoryService.CategoryCreateJob(jobCategory).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
                  });

                  successMsg = (successMsg == '') ? njobcode : (successMsg + ',' + njobcode);

                });

              }

            }
            if (!result?.methodResponse?.isMultiplejobs) {
              this._toastr.success('Job ' + successMsg[1] + ' ' + strMsgHeader, 'Success');
            } else {
              this._toastr.success('Job ' + successMsg + ' ' + strMsgHeader, 'Success');
            }
            this.clearFreqVal();
            this.closeCreateEditJobsPopUp.emit();
            this.GetStandardWorkflowView.emit(result.result[0]);
            this.createJobTableShow = false;
            this.resetJobform();
            this.cleanJobform(clientJobForm);
          }
          else {
            if (result.methodResponse.errorCode === -1) {
              this.getExistingJobDetailsForClient();
              if (Array.isArray(result.methodResponse.listofjobcode)) {
                result.methodResponse.listofjobcode.forEach(job => {
                  job.errorCode === -1 ? this._toastr.warning(job.message, 'Failed') : null;
                })
              } else {
                this._toastr.warning(result.methodResponse.message, 'Failed');
              }
            } else {
              this._toastr.warning(result.methodResponse.message, 'Failed');
            }
            this._toastr.warning(result.methodResponse.message, 'Failed');
            this.createJobTableShow = true;
            let sumtime: any = "0";
            let sumcost: any = "0";
            for (let i = 0; i < this._lstTempAssignee.length; i++) {
              sumcost = parseFloat(sumcost) + parseFloat(this._lstTempAssignee[i].cost == "-" ? 0 : this._lstTempAssignee[i].cost);
              sumtime = this.CalculateTotalTimeforJob(parseFloat(sumtime), parseFloat((this._lstTempAssignee[i].time == "-" || this._lstTempAssignee[i].time == "") ? 0 : this._lstTempAssignee[i].time.toString().replace(":", ".")));
            }
            this.totalassignedtime = Number(sumtime) == 0 ? "-" : this.ConvertNumberToTimeinJobs(sumtime).replace(".", ":");
            this.totalcost = Number(sumcost) == 0 ? "-" : sumcost.toFixed(2);
            if (this._lstTempAssignee.length > 0) {
              this.createJobTableShow = true;
            }
            for (let i = 0; i < this._lstTempAssignee.length; i++) {
              this._lstTempAssignee[i].time = this.ConverttoTimeFormatforJob(this._lstTempAssignee[i].time.toString().replace(":", "."));
              this._lstTempAssignee[i].cost = Number(this._lstTempAssignee[i].cost) == 0 ? "-" : this._lstTempAssignee[i].cost;
              this._lstTempAssignee[i].rateperHour = Number(this._lstTempAssignee[i].rateperHour) == 0 ? "-" : this._lstTempAssignee[i].rateperHour;
            }
            this.GetStandardWorkflowView.emit(result.result[0]); this.createJobTableShow = false;
          }

        },
        error: () => {
          this._toastr.error('An error occurred. Please try again.', 'Error');
        }
      });
  }

  syncEstimateWithMaster(masterData, estimateGroups) {
    if (!masterData?.length || !estimateGroups?.length) {
      return;
    }

    const masterMap = new Map();
    masterData.forEach(group => {
      masterMap.set(group.taskGroupName, group.tasks);
    });

    estimateGroups.forEach(group => {
      const masterTasks = masterMap.get(group.taskGroupName);
      if (!masterTasks) return;

      const existingIds = new Set(
        group.tasks.map(t => t.templateTaskId)
      );

      const missingTasks = masterTasks.filter(task => !existingIds.has(task.taskId));

      const newTasks = missingTasks.map(task => ({
        ...structuredClone(task),
        templateTaskId: task.taskId,
        taskId: this.getUniqueId(),
        taskgroupId: group.taskgroupId,
      }));

      group.tasks.push(...newTasks);
    });
  }

  formatDate(dateObject, dateString) {
    let formatted;
    const localDate = this.setSystemTime(new Date(dateObject));
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
    if (dateString == 'DueDate') {
      return formatted = `${year}-${month}-${day}`;
    } else {
      return formatted = `${year}-${month}-${day}`;
    }
  }

  setSystemTime(date: Date): Date {
    const now = new Date();
    date.setHours(
      now.getHours(),
      now.getMinutes(),
      now.getSeconds(),
      now.getMilliseconds()
    );
    return date;
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  GetClientProfileById(ClientId) {
    this._clientService.getClientDetailsById(Number(ClientId)).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (res) {
        this.jobDataModal.teamId = res.teamId != "" ? res.teamId : undefined;
        this.jobDataModal.managerId = res.managerId != "" ? res.managerId : undefined;
        this.jobDataModal.partnerId = res.partnerId != "" ? res.partnerId : undefined;
        this.officeData.selectedOfficeId = res?.officeId || null;
        this.bindEmptyTemplate();
        this.openJobToAdd();
        this.lastselectedmanager = this.jobDataModal.managerId;
        this.lastselectedpartner = this.jobDataModal.partnerId;
      }
    });
  }

  /**
   * Triggered when the "Add Job" is clicked from the ''Jobs'' section in the "My Timesheet" tab. (Timesheet Module → My Timesheet tab → Jobs → Add Job).
   * Fetches client details by clientId to prepopulate the office field
   * @param clientId - It contains clientId
   */
  getClientDataById(clientId: any) {
    this._clientService.getClientDetailsById(Number(clientId)).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (res) => {
        if (res) {
          this.jobDataModal.teamId = res?.teamId || undefined;
          this.jobDataModal.managerId = res?.managerId || undefined;
          this.jobDataModal.partnerId = res?.partnerId || undefined;
          this.officeData.selectedOfficeId = res?.officeId || null;
        }
      },
      error: (error: any) => {
        // Handle the error scenario if needed.
      }
    });
  }

  getDivisionByJobTypeId(jobTypeId: number) {         //Developer : Sasmit, Ticket: CUST-4185, Date: 13-Sept-2024
    this._jobService.GetDivisionByJobTypeId(jobTypeId).pipe(takeUntil(this.unsubscribe)).subscribe(
      (response: any) => {
        if (response) {
          this.jobDataModal.divisionId = response[0]?.divisionId || undefined;
        }
      },
      (error) => {
        this._toastr.error(error.message);
      }
    );
  }

  onRecurrancePeriodOnChange(event: any, index: number): void {
    const selectedDate = event.value.toDate();
    const endMonth = selectedDate.getMonth() + 1;
    const endOn = selectedDate.getDate();
    this.datas[index].Period_on = selectedDate;
    this.datas[index].endmonth = endMonth;
    this.datas[index].EndOfmonth = endOn;
    let isRowValid = true;
    const periodData = this.datas[index];
    if (!periodData.selctedStartsDate ||
      !periodData.selctedStartsDay ||
      !periodData.selctedStartsMonth ||
      (periodData.ends === 'On' && !periodData.Period_on) ||
      (periodData.ends === 'After' && !periodData.selctedEndDay)) {
      isRowValid = false;
    }
    this.validationStates[index] = !isRowValid;
  }
  onRecurranceQuarterOnChange(event: any, index: number): void {
    const selectedDate = event.value.toDate();
    const endMonth = selectedDate.getMonth() + 1;
    const endOn = selectedDate.getDate();
    this.quarterDatas[index].Period_QtrOn = selectedDate;
    this.quarterDatas[index].quartendmonth = endMonth;
    this.quarterDatas[index].quartEndOfmonth = endOn;
    let isRowValid = true;
    const periodQuarterlyData = this.quarterDatas[index];
    if (!periodQuarterlyData.selctedQuarterStartsDate ||
      !periodQuarterlyData.selctedQuarterStartsDay ||
      !periodQuarterlyData.selctedQuarterStartsMonth ||
      (periodQuarterlyData.quarterendsby === 'On' && !periodQuarterlyData.Period_QtrOn) ||
      (periodQuarterlyData.quarterendsby === 'After' && !periodQuarterlyData.selctedQuarterEndDay) || !periodQuarterlyData.quarterendsby) {
      isRowValid = false;
    }
    this.validationStates[index] = !isRowValid;
  }
  mapRecurrenceData(dataArray: any[], isQuarterly: boolean = false): any[] {
    return dataArray
      .filter(data => data.isEnabled)
      .map(data => {
        const endTypeId = isQuarterly
          ? this.QuarterEndBy.find(type => type.quarterendsby === data.quarterendsby)?.id || null
          : this.EndBy.find(type => type.ends === data.ends)?.endId || null;
        return {
          PeriodMonth: isQuarterly ? data.id : data.id,
          StartOn: isQuarterly ? data.selctedQuarterStartsDate : data.selctedStartsDate,
          DayName: isQuarterly ? data.selctedQuarterStartsDay : data.selctedStartsDay,
          StartMonth: isQuarterly ? data.selctedQuarterStartsMonth : data.selctedStartsMonth,
          EndType: endTypeId,
          EndMonth: (isQuarterly ? data.quarterendsby : data.ends) === 'On' ? (isQuarterly ? data.quartendmonth : data.endmonth) : 0,
          EndOn: (isQuarterly ? data.quarterendsby : data.ends) === 'On' ? (isQuarterly ? data.quartEndOfmonth : data.EndOfmonth) : 0,
          DayCount: (isQuarterly ? data.quarterendsby : data.ends) === 'After' ? (isQuarterly ? data.selctedQuarterEndDay : data.selctedEndDay) : 0,
        }
      });
  }

  public teamMembers = [];
  getTeamMembers(team: any) {
    this._clientService.GetTeamMembers(team).pipe(takeUntil(this.unsubscribe)).subscribe(
      response => {
        for (let i = 0; i < response.length; i++) {
          this.teamMembers.push(...response[i].groupMembers.map(term => term.memberId));
        }
        this.setFilteredAssignUserOptions();
      }
    )

  }


  GetCustomFieldsforQuicklinksByRoleforJob(JobId: any, sId: any) {
    this._jobService.GetCustomFieldsByRole(sId, JobId).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (result) => {
        this.tempcfqjobitem = result;
        let jobitem = [];
        this.tempcfqjobitem?.forEach((childobj) => {
          if (childobj.customFieldValues.length > 0) {

            if (childobj.fieldType == 'Date') {
              jobitem.push({
                id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
                helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
                sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: (childobj.value === null || childobj.value === "" || childobj.value === "undefined") ? undefined : new Date(childobj.value), customFieldValues: childobj.customFieldValues,
                  cfdropdown: this.parseJsonSafe(childobj.customFieldValues, [])
              });
            }
            else if (childobj.fieldType == 'Checkbox' && JobId != 0 && childobj.value != '') {
              jobitem.push({
                id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
                helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
                sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value, customFieldValues: childobj.value,
                cfdropdown: this.parseJsonSafe(childobj.value, [])
              });
            }
            else if (childobj.fieldType == 'User') {
              jobitem.push({
                id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
                helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
                sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible,
                value: childobj.value ? childobj.value.split(',').map(x => x?.toString().trim().replace(/^['"]+|['"]+$/g, '')).filter(x => x).map(x => ({ id: x })) : [], customFieldValues: childobj.customFieldValues, cfdropdown: [], _userInfo: []
              });
            }
            else {
              if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault) {
                const darray = this.parseJsonSafe(childobj.customFieldValues, [] as any[]);
                childobj.value = darray[0]["dropvalueId"].toString();
              }
              if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault == false) {
                childobj.value = 0;
              }

              if (childobj.fieldType == "Dropdown List") {
                childobj.value = isNaN(+childobj.value) ? 0 : +childobj.value;
                const options = this.parseJsonSafe(childobj.customFieldValues, [] as any[]);
                options.unshift({ dropvalueId: 0, dropvalue: childobj.placeHolder, isHidden: true });
                childobj.customFieldValues = JSON.stringify(options);
              }
              jobitem.push({
                id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
                helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
                sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value, customFieldValues: childobj.customFieldValues,
                cfdropdown: this.parseJsonSafe(childobj.customFieldValues, [])
              });
            }
          }
          else {
            if (childobj.fieldType == 'Date') {
              jobitem.push({
                id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
                helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
                sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: (childobj.value === null || childobj.value === "" || childobj.value === "undefined") ? undefined : new Date(childobj.value), customFieldValues: childobj.customFieldValues
                 });
            }
            else {
              if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault) {
                const darray = this.parseJsonSafe(childobj.customFieldValues, [] as any[]);
                childobj.value = darray[0]["dropvalueId"].toString();
              }
              if (childobj.fieldType == "Dropdown List" && childobj.value == "" && childobj.isFirstdefault == false) {
                childobj.value = 0;
              }

              if (childobj.fieldType == "Dropdown List") {
                childobj.value = isNaN(+childobj.value) ? 0 : +childobj.value;
                const options = this.parseJsonSafe(childobj.customFieldValues, [] as any[]);
                options.unshift({ dropvalueId: 0, dropvalue: childobj.placeHolder, isHidden: true });
                childobj.customFieldValues = JSON.stringify(options);
              }
              jobitem.push({
                id: childobj.id, fieldType: childobj.fieldType, datatype: childobj.datatype, fieldLabel: childobj.fieldLabel, description: childobj.description,
                helpText: childobj.helpText, placeHolder: childobj.placeHolder, isFirstdefault: childobj.isFirstdefault, isorderedAlphabetically: childobj.isorderedAlphabetically,
                sections: childobj.sections, isReadOnly: childobj.isReadOnly, isVisible: childobj.isVisible, value: childobj.value, customFieldValues: childobj.customFieldValues
              });
            }
          }
        });
        this.cfqjobitem = jobitem;
        this.createCFUserDropdowns();

      },
      error: (err) => {
        this._toastr.error(err.message);
      }
    });
  }

  createCFUserDropdowns() {
    this.cfqjobitem.forEach((field) => {
      if (field.fieldType == 'User') {
        field.value = field.value || [];

        if (field.customFieldValues === 'Users') {
          field.cfdropdown = this.allActiveUsers.map(x => ({
            id: x.userId,
            text: `${x.fullName} - ${x.email}`
          }))

          field.value.forEach(x => {
            const user = this.getCustomFieldUserById(x.id)
            x.text = user?.fullName || '';
          })
          this.onCFUserDropdownChange(field);
        }

      }
    })
  }


  chkqjobcustomfield(event: any, Id: number, i: any) {
    let Arr = this.parseJsonSafe(this.cfqjobitem[i].customFieldValues, [] as any[]);
    if (event.target.checked) {

      for (let val of Arr) {
        if (val.dropvalueId === Id) {
          val.status = true;
          this.checkBoxIds.push(val);
        }
      }
      this.cfqjobitem[i].customFieldValues = JSON.stringify(Arr);
    }
    else {
      if (Arr.length > 0) {
        let checkeditem = Arr.filter(obj => obj.dropvalueId === Id);
        if (checkeditem) {
          checkeditem[0].status = false;
          this.checkBoxIds.push(checkeditem[0]);
        }
        this.cfqjobitem[i].customFieldValues = JSON.stringify(Arr);
      }
    }
  }

  public checkLstResData = [];

  ediCheckBoxData() {
    const indexData = this.cfqjobitem.findIndex(obj => obj.fieldType === 'Checkbox');
    const cfqldata = this.cfqjobitem.filter(obj => obj.fieldType === 'Checkbox');
    if (cfqldata.length > 0) {
      this.checkLstResData = cfqldata[0].cfdropdown;
      for (let val of this.checkBoxIds) {
        this.checkLstResData.forEach((element, index) => {
          if (element.dropvalueId === val.dropvalueId) {
            this.checkLstResData[index] = val;
          }
        });
      }
      this.cfqjobitem[indexData].customFieldValues = JSON.stringify(this.checkLstResData);
    }
    this.checkBoxIds = [];
  }
  eventChangeInqCustomDropdown(event) {
    return;
  }

  newDynamic: any = {};

  Addrow() {
    this._lstTempAssignee.push({
      userId: undefined, name: "", role: "", rateperHour: "-", time: "", cost: "-", isManagerPartner: 0, _billrateId: 0
    });
    this.TimeErrorMsg = false;
  }

  CalculateTotalTimeforJob(estime, actime) {
    estime = estime.toFixed(2);
    actime = actime.toFixed(2);
    let etime = estime.toString();
    let atime = actime.toString();
    let rtime = 0;
    let sec_len;
    let secs
    let et = etime.split('.');
    let at = atime.split('.');
    if (estime > 0 && actime > 0) {

      et[1] = Number(et[1]) + Number(at[1]);
      if (Number(et[1]) > 59) {
        let x = (Number(et[1]) / 60);
        etime = x.toString();
        let val = etime.split('.');
        rtime = Number(et[0]) + Number(at[0]) + Number(val[0]);
        secs = Number(et[1]) % 60;
        sec_len = secs.toString();
        rtime = rtime + (secs / 100);
        return this.ConvertNumberToTimeforJob(rtime);
      }
      else {
        et[0] = Number(et[0]) + Number(at[0]);
        if (Number(et[1]) > 9)
          sec_len = et[1].toString().length;
        else
          sec_len = 2;
        secs = (Number(et[1]) / 100);
        rtime = rtime + Number(et[0]) + secs;
        return this.ConvertNumberToTimeforJob(rtime);
      }
    }
    else if (Number(estime) == 0 && Number(actime) > 0) {
      return this.ConvertNumberToTimeforJob(actime);
    }
    else if (Number(estime) > 0 && Number(actime) == 0) {
      return this.ConvertNumberToTimeforJob(estime);
    }
    else if ((Number(actime) >= 0 && Number(estime) < 0)) {
      if (et[1].length == 1)
        et[1] = (et[1]) * Math.pow(10, et[1].length);
      if (at[1].length == 1)
        at[1] = (at[1]) * Math.pow(10, at[1].length);

      if ((Number(estime) * (-1)) > Number(actime)) {
        if (Number(et[1]) > Number(at[1])) {
          et[1] = Number(et[1]) - Number(at[1]);
          et[1] = Number(et[1]) * (-1);
        }
        else {
          if (Number(et[0]) >= 1) {
            et[1] = (Number(et[1]) + 60) - Number(at[1]);
            et[0] = Number(et[0]) - 1;
            et[1] = Number(et[1]) * (-1);
          }
        }
      }
      else {
        if (Number(et[1]) > Number(at[1])) {
          if (Number(at[0]) >= 1) {
            et[1] = (Number(at[1]) + 60) - Number(et[1]);
            at[0] = Number(at[0]) - 1;

          }
        }
        else {
          et[1] = Number(at[1]) - Number(et[1]);
        }
      }

      etime = (Number(et[1]) / 60).toString();
      let val = etime.split('.');
      rtime = Number(et[0]) + Number(at[0]) + Number(val[0]);
      secs = Number(et[1]) % 60;
      sec_len = secs.toString();
      rtime = rtime + (secs / 100);
      if (rtime < 0)
        return rtime = 0 - this.ConvertNumberToTimeforJob(rtime * (-1));
      else
        return this.ConvertNumberToTimeforJob(rtime);
    }
    else if (Number(estime) >= 0 && Number(actime) < 0) {
      if (et[1].length == 1)
        et[1] = (et[1]) * Math.pow(10, et[1].length);
      if (at[1].length == 1)
        at[1] = (at[1]) * Math.pow(10, at[1].length);

      if ((Number(actime) * (-1)) > Number(estime)) {
        if (Number(at[1]) > Number(et[1])) {
          et[1] = Number(at[1]) - Number(et[1]);
          et[1] = Number(at[1]) * (-1);
        }
        else {
          if (Number(at[0]) >= 1) {
            et[1] = (Number(at[1]) + 60) - Number(et[1]);
            at[0] = Number(at[0]) - 1;
            et[1] = Number(at[1]) * (-1);
          }
        }
      }
      else {
        if (Number(at[1]) > Number(et[1])) {
          if (Number(at[0]) >= 1) {
            et[1] = (Number(et[1]) + 60) - Number(at[1]);
            et[0] = Number(et[0]) - 1;

          }
          else if ((Number(at[0]) * (-1)) >= 1) {
            et[1] = (Number(et[1]) + 60) - Number(at[1]);
            et[0] = Number(et[0]) - 1;

          }
          else {
            et[1] = (Number(et[1]) + 60) - Number(at[1]);
            et[0] = Number(et[0]) - 1;
          }
        }
        else {
          et[1] = Number(et[1]) - Number(at[1]);
        }
      }
      etime = (Number(et[1]) / 60).toString();
      let val = etime.split('.');
      rtime = Number(et[0]) + Number(at[0]) + Number(val[0]);
      secs = Number(et[1]) % 60;
      sec_len = secs.toString();
      rtime = rtime + (secs / 100);
      if (rtime < 0)
        return rtime.toFixed(2);
      else
        return this.ConvertNumberToTimeforJob(rtime);
    }
    else if (Number(estime) < 0 && Number(actime) < 0) {
      et[1] = (Number(et[1]) + Number(at[1])) * -1;
      if (Number(et[1]) > 59) {
        let x = (Number(et[1]) / 60);
        etime = x.toString();
        let val = etime.split('.');
        rtime = ((Number(et[0]) + Number(at[0])) * (-1)) + Number(val[0]);
        secs = Number(et[1]) % 60;
        sec_len = secs.toString();
        rtime = 0 - rtime + (secs / 100);
        if (rtime < 0)
          return rtime = 0 - this.ConvertNumberToTimeforJob(rtime * (-1));
        else
          return this.ConvertNumberToTimeforJob(rtime);
      }
      else {
        et[0] = (Number(et[0]) + Number(at[0])) * -1;
        rtime = Number(et[0]);
        if (Number(et[1]) > 0)
          rtime = 0 - rtime + ((Number(et[1]) / 100) * (-1));
        else
          rtime = 0 - rtime;
        return this.ConvertNumberToTimeforJob(rtime);
      }
    }
    else {
      rtime = Number(actime) + Number(estime);
      return this.ConvertNumberToTimeforJob(rtime);
    }
  }

  ConvertNumberToTimeforJob(inputVal) {
    inputVal = inputVal != '' && inputVal != undefined ? Number(inputVal) : 0;
    let decimalTimeString = inputVal.toFixed(2);
    let io = decimalTimeString.split('.');
    if (Number(io[1]) > 59) {
      let c_minute = "" + (Math.floor(Number(io[1])) % 60);
      if (c_minute.length == 1) {
        c_minute = '0' + c_minute;
      }
      let temp_hours = ("" + (Math.floor(Number(io[1])) / 60)).split('.');
      let c_hours = Number(io[0]) + Number(temp_hours[0]);
      let _time = Number(c_hours + "." + c_minute);
      return _time;
    }
    return inputVal.toFixed(2);
  }

  ConverttoTimeFormatforJob(item: any) {
    if (item == "-" || Number(item) == 0 || item == "")
      return "";
    let t = Number(item).toFixed(2);
    return t.toString().replace('.', ':');
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 47 && charCode < 59) {
      return true;
    } else { return false; }

  }

  ShowDate() {
    let today = new Date();
    this.jobDataModal.startDate = new Date(today);
    this.jobDataModal.dueDate = new Date(today);
    let tomorrow = new Date();
    let nextdate = new Date();
    let day = new Date(nextdate.setDate(today.getDate() + 28));
    let x = day.getDay();
    if (x == 0)
      day = new Date(tomorrow.setDate(today.getDate() + 29));
    else if (x == 6)
      day = new Date(tomorrow.setDate(today.getDate() + 30));
    else
      day = new Date(tomorrow.setDate(today.getDate() + 28));
    this.jobDataModal.dueDate = new Date(day);
  }

  CheckQoute(value) {
    let val = value.toString().split('.');
    if (val.length == 2)
      this.jobDataModal.quote = val[0].replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '.' + val[1];
    else
      this.jobDataModal.quote = val[0].replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return this.jobDataModal.quote;
  }

  DecimalCheck(evt: any) {
    let theEvent = evt || window.event;
    let key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    if (key == ".") {
      let _temp = this.jobDataModal.quote.split('.')
      if (_temp.length > 1)
        theEvent.preventDefault();
    }
    let regex = /^[0-9.\b]+$/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  ConvertTimeInOnlyHrs(time: any) {
    if (time < 0) { return 0 }
    let _temp = time.toString().split('.');
    if (_temp.length > 1)
      return Number(_temp[1] / 60) == 0 ? Number(_temp[0]) : Number(_temp[0]) + Number(_temp[1] / 60);
    else
      return Number(_temp[0]);
  }

  onBillRateSelect(item: any, i: number) {
    if (item != undefined) {
      this.checkDisableButton = false;
      let item1 = this._lstTempAssignee[i].multiBillrates.filter(b => b.billRateId == this._lstTempAssignee[i]._billrateId)[0];
      this._lstTempAssignee[i].rateperHour = item1.billrate;
      this.CalculateCost(this._lstTempAssignee[i]);

    }
  }

  public jobPriorityList: any = [];
  getPriorityDropdownList() {
    this._jobTypeService.GetJobPriorityValues().subscribe(respnse => {
      this.jobPriorityList = respnse;
      if (this.jobDataModal.priority == undefined) {
        const value = this.jobPriorityList.find(item => item.isDefault == true)
        this.jobDataModal.priority = value.jobPriorityId;
      }
    }, error => console.error(error));
  }

  onSelectStatus(data: any) {
    this.jobDataModal.jobstatusId = data.statusId;
    this.checkDisableButton = false;
  }

  getSelectedStatus() {
    let hasStatus = false;
    let status = '';
    if (this.jobDataModal.jobstatusId && this.statuslist?.length) {
      this.statuslist.forEach(ele => {
        const record = ele.data.filter(x => x.statusId == this.jobDataModal.jobstatusId);
        if (record.length) {
          status = record[0].statusName;
          hasStatus = true;
          return record[0].statusName;
        }
      })
    }
    return !hasStatus ? this.selectedStatus : status;
  }

  masterTaskList: any = [];
  createJobScreenNext(event) {
    this.assignAndEstimate.Assign.staff = this.removeDuplicates(this.assignAndEstimate.Assign.staff);
    this.currentScreenActive += event;
    this.getTeamMembers(this.jobDataModal.teamId);
    if (this.isEditMode) {
      this.filterTasksInEditMode();
    }

  }

  filterTasksInEditMode() {
    this.assignAndEstimate.Estimate = structuredClone(this.masterTaskList);
    this.assignAndEstimate.Estimate = this.assignAndEstimate.Estimate.filter(
      (item, index, self) =>
        index === self.findIndex(t => t.taskgroupId === item.taskgroupId)
    );
    let data = this.assignAndEstimate.Estimate;
    let jobCategory = this.jobCategoryselectedItems?.reduce((total, item) => total + item?.item_id, 0);
    data?.forEach(estimate => {
      estimate.tasks = estimate?.tasks?.filter(task => {

        if (jobCategory === 1 || jobCategory === 5) {
          return task.taskCategory === 1 || task.taskCategory === 3 || task.taskCategory === 5;
        }
        if (jobCategory === 2 || jobCategory === 6) {
          return task.taskCategory === 2 || task.taskCategory === 3 || task.taskCategory === 4 || task.taskCategory === 5;
        }
        if (jobCategory === 4) {
          return false;
        }
        return true;
      });
    });

    this.assignAndEstimate.Estimate = data?.filter(estimate => estimate.tasks.length > 0);
  }

  removeDuplicates(staffArray) {
    const uniqueStaff = [];
    const seenCombinations = new Set();

    staffArray.forEach(staff => {
      const combinationKey = `${staff.userId}-${staff.jobLevelRoleId}`;
      if (!seenCombinations.has(combinationKey)) {
        seenCombinations.add(combinationKey);
        uniqueStaff.push(staff);
      }
    });

    return uniqueStaff;
  }


  cerateJobBackScreen(event: any) {
    this.currentScreenActive += event;
  }

  openSubMenu(trigger) {
    trigger.openMenu();
  }

  closeSubMenu(trigger) {
    trigger.closeMenu();
  }

  setRecurranceYear() {
    if (!this.isEditMode) {
      this.recurranceData.FY = this.jobDataModal.financialYear;
    }
  }
  setRecurranceFrequency() {
    if (!this.isEditMode) {
      this.lastTab = this.jobselectedFrequency === 'None' ? 2 : 3;
      this.recurranceData.Period = [];
      this.setRecurrancePeriod();
    }
  }
  qtrFlagCheck: boolean = false; monthFlagCheck: boolean = false; annualFlagCheck: boolean = false;
  onChangeRecurranceFrequency() {
    if (this.recurranceData.Frequency == "Annually") {
      this.onAnnualPeriodChange();
    }
    switch (this.recurranceData.Frequency) {
      case 'Monthly':
        this.recurranceData.Period = this.statusMonthlyModel;
        this.monthFlagCheck = this.datas.filter(m => m.isEnabled == true)?.length > 0 ? true : false;
        break;
      case 'Quarterly':
        this.recurranceData.Period = this.statusQuarterlyModel;
        this.qtrFlagCheck = this.quarterDatas.filter(m => m.isEnabled == true)?.length > 0 ? true : false;
        break;
      case 'Annually':
        this.recurranceData.Period = [{ PeriodVal: "Annually", JobId: 0, NewJobId: 0, IsRecurrenceCreated: false }];
        this.annualFlagCheck = this.annualDatas.filter(m => m.isEnabled == true)?.length > 0 ? true : false;
        break;
      default:
        this.recurranceData.Period = [];
        break;
    }
    this.recurranceData.Start_ReccDate = null;
    this.recurranceData.Stop_ReccDate = null;
  }
  setRecurrancePeriod() {
    if (!this.isEditMode) {
      switch (this.jobselectedFrequency) {
        case 'Monthly':
          this.recurranceData.Period = this.statusMonthlyModel;
          this.recurranceData.Frequency = 'Monthly';
          break;
        case 'Quarterly':
          this.recurranceData.Period = this.statusQuarterlyModel;
          this.recurranceData.Frequency = 'Quarterly';
          break;
        case 'Annually':
          this.recurranceData.Period = [{ PeriodVal: "Annually", JobId: 0, NewJobId: 0, IsRecurrenceCreated: false }];
          this.recurranceData.Frequency = 'Annually';
          break;
        default:
          this.recurranceData.Period = [];
          this.recurranceData.Frequency = 'Monthly';
          break;
      }
    }
  }

  array_sort(array: any[], key: string) {
    array.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
  }
  updateTaskGroupAssigneeOverview() {
    this.assignAndEstimate?.Estimate.forEach(group => {
      group._groupAssigneeOverview

      let isAnyUnassigned = false;
      const unassigned = {
        name: 'Unassigned',
        unit: 0,
      };
      const _assigneeData = [];
      group?.tasks.forEach(task => {
        task?._estimateDataList?.forEach(estimate => {
          if (!estimate.userId) {
            isAnyUnassigned = true;
            unassigned.unit += estimate.unit || 0;
          } else {
            const user = {
              name: estimate.fullName,
              unit: estimate.unit || 0,
            }

            const existing = _assigneeData?.find(x => x.name === user.name);
            if (existing) {
              existing.unit += user.unit;
            } else {
              _assigneeData.push(user);
            }
          }

        });
      });

      group._groupAssigneeOverview = _assigneeData;
      this.array_sort(group._groupAssigneeOverview, 'name');

      if (isAnyUnassigned) {
        group._groupAssigneeOverview.push(unassigned);
      };
    })
  }

  getAssigneeUserJobLevelRoleId(userId: string) {
    let roleId = 0;

    loop: for (const _user of this.assignAndEstimate.Assign.staff) {
      if (_user.userId === userId) {
        roleId = _user.jobLevelRoleId;
        break loop;
      }
    }

    return roleId;
  }

  showCFUserDropdown(event: any) {
    event._isVisibleInput = true;
  }
  hideCFUserDropdown(field: any) {
    if (field._isDropdownInteracted) {
      field._isVisibleInput = !field._isVisibleInput;
      field._isDropdownInteracted = false;
    } else {
      field._isDropdownInteracted = true;
    }
  }
  onCFUserDropdownChange(field: any) {
    field.value = field.value || [];

    field._userInfo = field.value.map(x => {
      const user = this.getCustomFieldUserById(x.id)
      if (user) {
        return {
          fullName: user.fullName,
          shortName: this.getShortName(user.fullName),
          textColor: user.textColor,
          backgroundColor: user.backgroundColor
        }
      }
    })?.filter(x => x)
  }

  private normalizeCustomFieldUserId(userId: any): string {
    return (userId ?? '').toString().trim().replace(/^['"]+|['"]+$/g, '').toLowerCase();
  }

  private getCustomFieldUserById(userId: any): any {
    const normalizedUserId = this.normalizeCustomFieldUserId(userId);
    return this.allUsers.find(user => this.normalizeCustomFieldUserId(user.userId) === normalizedUserId);
  }

  onChangeJobLevelUser(event: { userId: string }, roleName: string) {
    let staff = this.assignAndEstimate.Assign.staff;
    const roleId = this.roles.find(x => x.roleName === roleName).roleId;

    let jobLevelAssigneeIndex = staff.findIndex(x => x.isJobLevelUser && x.jobLevelRoleId === roleId);
    const jobLevelAssignee = staff[jobLevelAssigneeIndex];
    const oldAssigneeId = jobLevelAssignee.userId;

    const newAssigneeId = event?.userId ?? null;
    const newAssigneeFullName = this.getUserById(newAssigneeId)?.fullName || '';
    const newAssigneeInitials = this.extractInitialsFromFirstName(newAssigneeFullName);

    if (newAssigneeId) {
      const existingAssigneeIndex = staff.findIndex(x => x.userId === newAssigneeId && x.jobLevelRoleId === roleId);
      jobLevelAssignee.userId = newAssigneeId;
      jobLevelAssignee.fullName = newAssigneeFullName;
      jobLevelAssignee._previousUserId = jobLevelAssignee.userId;
      if (existingAssigneeIndex === -1) {
        jobLevelAssignee.unit = this.getTotalEstimateForUser(jobLevelAssignee.userId, jobLevelAssignee.jobLevelRoleId) || 0;
        jobLevelAssignee.time = this.getTimeFromUnit(jobLevelAssignee.unit);
        this.setAssigneeRates(jobLevelAssignee);
      } else {
        const existingAssignee = staff[existingAssigneeIndex];
        const summedUnits = jobLevelAssignee.unit + existingAssignee.unit;

        const totalMinutes = summedUnits * this.firmSetting.unitvalue;
        staff[jobLevelAssigneeIndex] = {
          ...jobLevelAssignee,
          unit: summedUnits,
          time: this.getTimeFromUnit(summedUnits),
          isTimesheetEntry: existingAssignee.isTimesheetEntry,
          userRates: existingAssignee.userRates,
          selectedRate: existingAssignee.selectedRate,
          cost: (existingAssignee.selectedRate * (totalMinutes / 60)).toFixed(2),
        };
        staff = staff.splice(existingAssigneeIndex, 1)
      }
      this.assignAndEstimate.Estimate?.forEach(group => {
        group.tasks.forEach(task => {
          const taskUserIds = task._estimateDataList.filter(x => x.roleId === jobLevelAssignee.jobLevelRoleId).map(x => x.userId);
          const oldUserEstimate = task._estimateDataList.find(x => x.roleId === jobLevelAssignee.jobLevelRoleId && x.userId === oldAssigneeId);
          if (taskUserIds.includes(oldAssigneeId) && taskUserIds.includes(newAssigneeId)) {
            const newUserExistingEstimateIndex = task._estimateDataList.findIndex(x => x.userId === newAssigneeId);
            const newUserEstimate = task._estimateDataList[newUserExistingEstimateIndex];
            oldUserEstimate.unit = oldUserEstimate.unit + newUserEstimate.unit;
            oldUserEstimate.time = this.getTimeFromUnit(oldUserEstimate.unit);
            task._estimateDataList.splice(newUserExistingEstimateIndex, 1);
          }
          if (taskUserIds.includes(oldAssigneeId)) {
            oldUserEstimate.userId = newAssigneeId;
            oldUserEstimate.fullName = newAssigneeFullName;
            oldUserEstimate.initials = newAssigneeInitials;
          }
          task._assignedEstimates = task._estimateDataList.filter(x => x.userId);
          this.createUnsavedEstimatesList(task);
          this.setFilteredListForTask(task);
        })
      })

    } else {
      const roleRates = this.getRoleLevelRates(staff[jobLevelAssigneeIndex].jobLevelRoleId);
      staff[jobLevelAssigneeIndex] = {
        ...new AssignedUser,
        isFirstUserForRole: true,
        jobLevelRoleId: this.roles.find(x => x.roleName === roleName)?.roleId,
        jobLevelRoleName: roleName,
        isJobLevelUser: true,
        userRates: roleRates,
        selectedRate: roleRates[0]?.ValueAmt
      }
      this.assignAndEstimate?.Estimate.forEach(estimate => {
        estimate.tasks.forEach(task => {
          task._estimateDataList.filter(x => jobLevelAssignee.jobLevelRoleId === x.roleId && oldAssigneeId === x.userId).forEach(estimate => {
            estimate.fullName = '';
            estimate.userId = null;
            estimate.initials = '';
          })
          task._assignedEstimates = task._estimateDataList.filter(x => x.userId);
          this.createUnsavedEstimatesList(task);
          this.setFilteredListForTask(task);
        })
      })
    }

    this.calculateAssigneeTimeCost();
    this.setFilteredAssignUserOptions();
    this.updateTaskGroupAssigneeOverview();
    this.setUnassignedData();
  }

  hideAllBreadkdowns() {
    this.assignAndEstimate?.Estimate.forEach(group => {
      group.tasks.forEach(task => {
        task._breakdownAvailableType = '';
        task._breakdownOpenType = '';
        task._estimateDataListUnsaved = this.common.copyObject(task._estimateDataList);
      })
    })
  }
  showAvailableBreakdown(task: EstimateTask, breakdownType: BreakdownType) {
    this.hideAllBreadkdowns();
    task._breakdownAvailableType = breakdownType;
  }
  openBreakdownPopup(task: EstimateTask, breakdownType: BreakdownType) {
    if (task._breakdownOpenType === breakdownType) {
      this.hideAllBreadkdowns();
      return;
    }
    this.hideAllBreadkdowns();
    task._breakdownAvailableType = breakdownType;
    task._breakdownOpenType = breakdownType;

    this.createUnsavedEstimatesList(task);
  }
  closeBreakdownPopup(task: EstimateTask) {
    this.hideAllBreadkdowns();
  }

  isBreakdownSaveDisabled(task: any): boolean {
    if (!task || !task._estimateDataListUnsaved) {
      return true;
    }

    return task._estimateDataListUnsaved.some((item: any) =>
      !item.roleId || item.roleId === 0
    );
  }
  
  saveBreakdownPopup(task: EstimateTask) {
    task._estimateDataListUnsaved = task._estimateDataListUnsaved.filter(x => x.roleId);
    task._estimateDataListUnsaved.forEach(estimate => {
      if (estimate.userId) {
        estimate.fullName = this.getUserById(estimate.userId)?.fullName ?? '';
        estimate.initials = this.extractInitialsFromFirstName(estimate.fullName ?? '');
      }
      estimate.roleName = this.getRoleById(estimate.roleId)?.roleName ?? '';
    })
    task._estimateDataList = task._estimateDataListUnsaved;
    task.unit = task._estimateDataListUnsaved.reduce((total, estimate) => {
      return total + estimate.unit;
    }, 0) || 0;
    task._estimateDataList.forEach(estimate => {
      this.onChangeUserForTaskEstimate(task, estimate);
    });
    this.updateTaskGroupAssigneeOverview();

    this.setTaskRoleNames(task);

    this.hideAllBreadkdowns();
  }

  setTaskRoleNames(task: EstimateTask) {
    task._taskRoleNames = Array.from(new Set(task._estimateDataList.map(x => x.roleName))).join(', ');
  }

  onSelectTaskEstimateUser(estimate: EstimateTaskData, task: EstimateTask, user: any) {
    estimate.fullName = user?.fullName || '';
    this.setFilteredListForTask(task);
  }
  addTaskEstimation(task: EstimateTask) {
    const anyEmptyRole = task._estimateDataListUnsaved.find(x => !x.roleId);
    if (anyEmptyRole) {
      return;
    };

    task._estimateDataListUnsaved.push({
      ...new EstimateTaskData,
    })
    this.setFilteredListForTask(task);
  }
  deleteTaskEstimation(task: EstimateTask, index) {
    task._estimateDataListUnsaved.splice(index, 1);
    this.setFilteredListForTask(task);
  }
  onEstimateUnitBlur(estimate: EstimateTaskData, task: EstimateTask) {
    estimate.unit = estimate.unit || 0;
    task._unitUnsaved = task._estimateDataListUnsaved.reduce((total, estimate) => {
      return total + estimate.unit;
    }, 0);
  }
  createUnsavedEstimatesList(task: EstimateTask) {
    task._estimateDataListUnsaved = this.common.copyObject(task._estimateDataList);

    this.setFilteredListForTask(task)
  }
  setFilteredListForTask(task: EstimateTask) {
    task._estimateDataListUnsaved.forEach(estimate => {
      estimate._availableRoles = this.getAvaiableRolesForTask(task, estimate.roleId);
      estimate._availableUsers = this.getAvaiableUsersForTask(task, estimate.userId);
    });

    task._assignedEstimates = task._estimateDataListUnsaved.filter(x => x.userId)
  }

  async onChangeEstimateType() {
    if (!this.jobDataModal.jobId && !this.jobDataModal.templateId) {
      if (this.jobDataModal.jobEstimateType === 'Job' && this.firmSetting.timeSheetlevel) {
        this.assignAndEstimate = new AssignAndEstimate;
        await this.setDefaultAssignees();
      } else {
        this.resetAssignAndEstimate();
      }
    }
  }
  onAssigneeUnitBlur(assignee: AssignedUser) {
    assignee.unit = assignee.unit || 0;
    this.calculateAssigneeTimeCost(assignee);
  }

  clearMonthlyRowData(row: periodData) {
    row.selctedStartsDate = null;
    row.selctedStartsDay = null;
    row.selctedStartsMonth = null;
    row.ends = null;
    row.endmonth = null;
    row.EndOfmonth = null;
    row.selctedEndDay = null;
    row.Period_on = null;
  }
  clearQuarterlyRowData(row: periodQuarterlyData) {
    row.selctedQuarterStartsDate = null;
    row.selctedQuarterStartsDay = null;
    row.selctedQuarterStartsMonth = null;
    row.quarterendsby = null;
    row.selctedQuarterEndOn = null;
    row.quartEndOfmonth = null;
    row.selctedQuarterEndDay = null;
    row.Period_QtrOn = null;
  }

  autoPopulateRecurrenceDefaults(frequency: string, data: any) {
    // Defensive initialization
    if (frequency === 'Quarterly') {
      data.selctedQuarterStartsDate ??= null;
      data.selctedQuarterStartsDay ??= null;
      data.selctedQuarterStartsMonth ??= null;
      data.quarterendsby ??= null;
      data.selctedQuarterEndDay ??= null;
    } else {
      data.selctedStartsDate ??= null;
      data.selctedStartsDay ??= null;
      data.selctedStartsMonth ??= null;
      data.ends ??= null;
      data.selctedEndDay ??= null;
    }

    const StartsDateDefault = { startsId: 1, startsWeek: '1st week' };
    const StartsWeekDefault = { WeekId: 1, StartsWeekDay: 'Monday' };
    const EndByDefault = 'After';

    if (frequency === 'Monthly') {
      const selectedMonth = data.monthly;
      const period = this.periodDetailForFirm.find(p => p.name === selectedMonth);

      const monthName = period?.startMonth || selectedMonth;

      data.selctedStartsDate = StartsDateDefault.startsId;
      data.selctedStartsDay = StartsWeekDefault.WeekId;

      const foundMonth = this.StartsMonth?.find(m => m.StartMonth.toLowerCase() === monthName.toLowerCase());
      if (foundMonth) {
        data.selctedStartsMonth = foundMonth.StartsMonthId;
      }

      data.ends = EndByDefault;
      data.selctedEndDay = this.jobDataModal.turnaround;
    }

    else if (frequency === 'Quarterly') {
      let quarter = data.quarterly;

      const quarterMatch = quarter?.match(/(Q[1-4])/);
      if (quarterMatch && quarterMatch[1]) {
        quarter = quarterMatch[1];
      }

      const period = this.periodDetailForFirm.find(p => p.name === quarter);
      const monthName = period?.startMonth || 'January';

      data.selctedQuarterStartsDate = StartsDateDefault.startsId;
      data.selctedQuarterStartsDay = StartsWeekDefault.WeekId;

      const foundMonth = this.StartsMonth?.find(m => m.StartMonth.toLowerCase() === monthName.toLowerCase());
      if (foundMonth) {
        data.selctedQuarterStartsMonth = foundMonth.StartsMonthId;
      }

      data.quarterendsby = EndByDefault;
      data.selctedQuarterEndDay = this.jobDataModal.turnaround;
    }

    else if (frequency === 'Annually') {
      // Use first quarter's start month as the annual start month
      const period = this.periodDetailForFirm.find(p => p.name === 'Q1');
      const monthName = period?.startDate || 'July';

      data.selctedStartsDate = StartsDateDefault.startsId;
      data.selctedStartsDay = StartsWeekDefault.WeekId;

      const foundMonth = this.StartsMonth?.find(m => m.StartMonth.toLowerCase() === monthName.toLowerCase());
      if (foundMonth) {
        data.selctedStartsMonth = foundMonth.StartsMonthId;
      }

      data.ends = EndByDefault;
      data.selctedEndDay = 365;
    }
  }

  selectedPeriods: string[] = [];
  onPeriodChange(selectedPeriods: any[]) {
    if (!this.recurrenceEnableChk) {
      this.setDefaultRecurrenceDate();
    } else {
      this.recurranceData.Start_ReccDate = null;
      this.recurranceData.Stop_ReccDate = null;
    }
    const selectedPeriodTexts = Array.isArray(selectedPeriods) ? selectedPeriods.map(item => item?.item_text).filter(text => !!text) : []; 

    this.datas.forEach(data => {
      if (!selectedPeriodTexts.includes(data.monthly)) {
        this.clearMonthlyRowData(data);
        data.isEnabled = false;
        data.ends = 'After';
      }
    });

    this.datas.forEach(data => {
      if (selectedPeriodTexts.includes(data.monthly)) {
        data.isEnabled = true;
        data.ends = 'After';
        this.autoPopulateRecurrenceDefaults('Monthly', data);
      }
    });
    this.monthFlagCheck = this.datas.filter(m => m.isEnabled == true)?.length > 0 ? true : false;
  }
  onAnnualPeriodChange() {
    this.annualDatas = [];
    let row: periodData = {
      selctedStartsDate: null,
      selctedStartsDay: null,
      selctedStartsMonth: null,
      endmonth: null,
      EndOfmonth: null,
      selctedEndDay: null,
      Period_on: null,
      isEnabled: true,
      ends: 'After',
      monthly: 'Annual',
      id: 7
    }

    this.annualDatas.push(row);
    this.annualFlagCheck = this.annualDatas.filter(m => m.isEnabled == true)?.length > 0 ? true : false;
  }

  selectedQuarters: string[] = [];
  onQuarterChange(selectedQuarters: any[]) {
    if (!this.recurrenceEnableChk) {
      this.setDefaultRecurrenceDate();
    } else {
      this.recurranceData.Start_ReccDate = null;
      this.recurranceData.Stop_ReccDate = null;
    }
    this.quarterDatas.forEach(data => {
      this.clearQuarterlyRowData(data);
      data.isEnabled = false;
      data.quarterendsby = 'After';
    });

    const selectedQuarterIds = Array.isArray(selectedQuarters) ? selectedQuarters.map(item => item?.item_text).filter(text => !!text) : [];
    this.quarterDatas.forEach(data => {
      if (selectedQuarterIds.includes(data.quarterly)) {
        data.isEnabled = true;
        data.quarterendsby = 'After';
        this.autoPopulateRecurrenceDefaults('Quarterly', data);
      }
    });
    this.qtrFlagCheck = this.quarterDatas.filter(m => m.isEnabled == true)?.length > 0 ? true : false;
  }
  getMappedQuarter(quarterly: string): string {
    return Object.keys(this.quarterMapping).find(key => this.quarterMapping[key] === quarterly);
  }
  onMonthSelected(selectedMonth: any) {
    const selectedMonthName = selectedMonth?.endmonth;
    if (selectedMonthName) {
      const monthIndex = this.getMonthIndexFromName(selectedMonthName);
      this.EndOf = this.generateDaysForMonth(monthIndex);
    }
  }
  onQuarterMonthSelected(selectedMonth: any) {
    const selectedMonthName = selectedMonth?.quartendmonth;
    if (selectedMonthName) {
      const monthIndex = this.getMonthIndexFromName(selectedMonthName);
      this.QuarterEndOf = this.generateDaysForQuarterMonth(monthIndex);
    }
  }
  getMonthIndexFromName(monthName: string): number {
    const monthMapping: { [key: string]: number } = {
      'January': 0,
      'February': 1,
      'March': 2,
      'April': 3,
      'May': 4,
      'June': 5,
      'July': 6,
      'August': 7,
      'September': 8,
      'October': 9,
      'November': 10,
      'December': 11
    };
    return monthMapping[monthName] ?? -1;
  }
  generateDaysForMonth(monthIndex: number): { EndOfmonthId: number, EndOfmonth: string }[] {
    const daysInMonth = this.getDaysInMonth(monthIndex);
    return Array.from({ length: daysInMonth }, (_, i) => ({
      EndOfmonthId: i + 1,
      EndOfmonth: `${i + 1}`
    }));
  }
  generateDaysForQuarterMonth(monthIndex: number): { quartEndOfmonth: string }[] {
    const daysInMonth = this.getDaysInMonth(monthIndex);
    return Array.from({ length: daysInMonth }, (_, i) => ({ quartEndOfmonth: `${i + 1}` }));
  }
  getDaysInMonth(monthIndex: number): number {
    const year = new Date().getFullYear();
    return new Date(year, monthIndex + 1, 0).getDate();
  }
  minDate: Date | null = null;
  minDates: Date[] = [];
  onSelectionChange(periodData: any, index: number) {
    const selectedWeekId = periodData.selctedStartsDate;
    const selectedDayId = periodData.selctedStartsDay;
    const selectedMonthId = periodData.selctedStartsMonth;

    const selectedWeek = this.startsDateMap[selectedWeekId];
    const selectedDay = this.startsWeekMap[selectedDayId];
    const selectedMonth = this.startsMonthMap[selectedMonthId];

    if (selectedWeek && selectedDay && selectedMonth) {
      const minDate = this.calculateStartDate(selectedWeek, selectedDay, selectedMonth);
      const index = this.datas.indexOf(periodData);
      this.updateMinDate(index, minDate);
    }
    let isRowValid = true;
    if (!periodData.selctedStartsDate ||
      !periodData.selctedStartsDay ||
      !periodData.selctedStartsMonth ||
      (periodData.ends === 'On' && !periodData.Period_on) ||
      (periodData.ends === 'After' && !periodData.selctedEndDay) || !periodData.ends) {
      isRowValid = false;
    }
    this.validationStates[index] = !isRowValid;
  }
  onSelectionQtrChange(periodQuarterlyData: any, index: number) {
    const selectedWeekId = periodQuarterlyData.selctedQuarterStartsDate;
    const selectedDayId = periodQuarterlyData.selctedQuarterStartsDay;
    const selectedMonthId = periodQuarterlyData.selctedQuarterStartsMonth;

    const selectedWeek = this.startsDateMap[selectedWeekId];
    const selectedDay = this.startsWeekMap[selectedDayId];
    const selectedMonth = this.startsMonthMap[selectedMonthId];

    if (selectedWeek && selectedDay && selectedMonth) {
      const minDate = this.calculateStartDate(selectedWeek, selectedDay, selectedMonth);
      const index = this.quarterDatas.indexOf(periodQuarterlyData);
      this.updateMinDate(index, minDate);
    }
    let isRowValid = true;
    if (!periodQuarterlyData.selctedQuarterStartsDate ||
      !periodQuarterlyData.selctedQuarterStartsDay ||
      !periodQuarterlyData.selctedQuarterStartsMonth ||
      (periodQuarterlyData.quarterendsby === 'On' && !periodQuarterlyData.Period_QtrOn) ||
      (periodQuarterlyData.quarterendsby === 'After' && !periodQuarterlyData.selctedQuarterEndDay) || !periodQuarterlyData.quarterendsby) {
      isRowValid = false;
    }
    this.validationStates[index] = !isRowValid;
  }

  validateInput(event: Event, periodData: any, index: number): void {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;


    value = value.replace(/[^0-9]/g, '');


    if (value.length > 3) {
      value = value.slice(0, 3);
    }


    const intValue = parseInt(value, 10) || 0;


    const validValue = Math.min(intValue, 999);


    inputElement.value = validValue.toString();
    periodData.selctedEndDay = validValue;
  }


  validateQuarterlyInput(event: Event, periodQuarterlyData: any, index: number): void {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;

    value = value.replace(/[^0-9]/g, '');

    if (value.length > 3) {
      value = value.slice(0, 3);
    }

    const intValue = parseInt(value, 10) || 0;
    const validValue = Math.min(intValue, 999);
    inputElement.value = validValue.toString();
    periodQuarterlyData.selctedQuarterEndDay = validValue;
  }

  updateMinDate(index: number, minDate: Date | null) {
    this.minDates[index] = minDate;
  }
  calculateStartDate(selectedWeek: number, selectedDay: string, selectedMonth: string): Date {
    const monthIndexMap = {
      'January': 1,
      'February': 2,
      'March': 3,
      'April': 4,
      'May': 5,
      'June': 6,
      'July': 7,
      'August': 8,
      'September': 9,
      'October': 10,
      'November': 11,
      'December': 12
    };

    const monthIndex = monthIndexMap[selectedMonth];

    const firstDayOfMonth = new Date(new Date().getFullYear(), monthIndex - 1, 1);

    const firstDayWeekDay = firstDayOfMonth.getDay();

    const weekStart = {
      'Monday': 1,
      'Tuesday': 2,
      'Wednesday': 3,
      'Thursday': 4,
      'Friday': 5,
      'Saturday': 6,
      'Sunday': 7
    };

    const selectedDayIndex = weekStart[selectedDay];

    const startDate = new Date(firstDayOfMonth);
    const daysToAdd = (selectedWeek - 1) * 7 + (selectedDayIndex - firstDayWeekDay + (firstDayWeekDay > selectedDayIndex ? 7 : 0));

    startDate.setDate(startDate.getDate() + daysToAdd);

    return startDate;
  }
  onStartRecurrenceDateChange(event) {
    const selectedStartDate = new Date(this.recurranceData.Start_ReccDate);

    this.mindueDate = new Date(selectedStartDate);

    this.recurranceData.Start_ReccDate = (moment as any)(event.value).toDate();

    const selectedStopDate = new Date(this.recurranceData.Stop_ReccDate);

    if (selectedStopDate && selectedStopDate < selectedStartDate) {
      this.recurranceData.Stop_ReccDate = null;
    }
  }
  validateMonthlyRecurrence(): boolean {
    let isMonthlyFormValid = true;

    this.datas.forEach((periodData, index) => {
      if (periodData.isEnabled) {
        let isRowValid = true;
      
        if (!periodData.selctedStartsDate ||
          !periodData.selctedStartsDay ||
          !periodData.selctedStartsMonth ||
          (periodData.ends === 'On' && !periodData.Period_on) ||
          (periodData.ends === 'After' && !periodData.selctedEndDay) ||
          !periodData.ends) {

          isRowValid = false;
          isMonthlyFormValid = false;
        }

        this.validationStates[index] = !isRowValid;
      } else {
        this.validationStates[index] = false;
      }
    });

    return isMonthlyFormValid;
  }
  validateQuarterlyRecurrence(): boolean {
    let isQuarterlyFormValid = true;

    this.quarterDatas.forEach((periodQuarterlyData, index) => {
      if (periodQuarterlyData.isEnabled) {
        let isRowValid = true;
        
        if (!periodQuarterlyData.selctedQuarterStartsDate ||
          !periodQuarterlyData.selctedQuarterStartsDay ||
          !periodQuarterlyData.selctedQuarterStartsMonth ||
          (periodQuarterlyData.quarterendsby === 'On' && !periodQuarterlyData.Period_QtrOn) ||
          (periodQuarterlyData.quarterendsby === 'After' && !periodQuarterlyData.selctedQuarterEndDay) ||
          !periodQuarterlyData.quarterendsby) {

          isRowValid = false;
          isQuarterlyFormValid = false;
        }

        this.validationStates[index] = !isRowValid;
      } else {
        this.validationStates[index] = false;
      }
    });

    return isQuarterlyFormValid;
  }

  validateAnnuallyRecurrence(): boolean {
    let isAnnuallyFormValid = true;

    this.annualDatas.forEach((periodData, index) => {
      if (periodData.isEnabled) {
        let isRowValid = true;

        if (!periodData.selctedStartsDate ||
          !periodData.selctedStartsDay ||
          !periodData.selctedStartsMonth ||
          (periodData.ends === 'On' && !periodData.Period_on) ||
          (periodData.ends === 'After' && !periodData.selctedEndDay) ||
          !periodData.ends) {

          isRowValid = false;
          isAnnuallyFormValid = false;
        }

        this.validationStates[index] = !isRowValid;
      } else {
        this.validationStates[index] = false;
      }
    });

    return isAnnuallyFormValid;
  }

  onClearCustomFieldDropdown(field: any) {
    field.value = 0;
  }

  validateUniqueJobName() {
    this.duplicateJobNames = [];

    if (this.jobDataModal.jobId) {
      this.checkAndAddDuplicateJobName(this.savedJobData.period || null);
    } else {
      const periodList = this.jobselectedFrequency === 'None' ? [] : (this.jobselectedFrequency === 'Monthly' ? this.statusMonthlyModel : this.statusQuarterlyModel);
      if (this.jobselectedFrequency === 'None' || !periodList?.length) {
        this.checkAndAddDuplicateJobName();
      } else {
        periodList.forEach(period => {
          this.checkAndAddDuplicateJobName(period.item_text);
        });
      }
    }
  }

  checkAndAddDuplicateJobName(period: any = null) {
    const name = this.checkFormattedJobName(period);
    if (name.isExists) {
      this.duplicateJobNames.push(name.formattedJobName);
    };
  }

  checkFormattedJobName(period: any = null) {
    const formattedJobName = this.common.getFormattedJobName({ jobName: this.jobDataModal.jobName, financialYear: this.jobDataModal.financialYear, period: period });

    return {
      formattedJobName,
      isExists: this.existingJobDetails.some(job => job.clientId == this.jobDataModal.clientId && job.formattedJobName === formattedJobName && job.jobId != this.jobDataModal.jobId),
    }
  }


  setStartDateAsToday(startDateDtpicker: MatDatepicker<Date>) {
    const todayDate = new Date();
    this.jobDataModal.startDate = todayDate;
    if (this.jobDataModal.turnaround != null && this.jobDataModal.startDate != null) {
      this.calculateDueDateFromStartAndTurnaround();
    }
    startDateDtpicker.close();
  }

  appendTodayButton() {
    const matcalendarContainer = document.getElementsByClassName('mat-datepicker-content')[0];
    this.startDateTodayBtnRef = document.getElementById('startDateTodayAction');

    if (this.startDateTodayBtnRef && matcalendarContainer) {
      if (!matcalendarContainer.contains(this.startDateTodayBtnRef)) {
        matcalendarContainer.appendChild(this.startDateTodayBtnRef);
      }
    }
  }

  removeTodayButton() {
    const originalContainer = document.querySelector('#startDateTodayWrapper');
    if (this.startDateTodayBtnRef && originalContainer) {
      originalContainer.appendChild(this.startDateTodayBtnRef);
    }
  }

  ngOnDestroy() {
    if (this.statusOwnerTimeout) {
      clearTimeout(this.statusOwnerTimeout);
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.officeData = null;
    this.compositeSub.unsubscribe();

    super.ngOnDestroy();
  }
  getOwnerList() {
    this._jobService
      .GetStatusOwnerForJob(this._jobId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response: any) => {
          this.ownerData = [];

          if (response) {
            let check = 0;

            response.forEach(element => {
              if (element.category === "Users" && check === 0) {
                check = 1;
                this.ownerData.push({
                  Category: "Users",
                  ownername: "Unassigned",
                  Id: 0
                });
              }

              this.ownerData.push({
                ownername: element.ownerName,
                Category: element.category,
                Id: element.userId,
                inviteStatus: element.inviteStatus
              });
            });
          }
          if (!this._jobId) {
            this.jobDataModal.statusOwnerId = 0;
          }

          if (this._jobId && this.jobDataModal.statusOwnerId == null) {
            this.jobDataModal.statusOwnerId = 0;
          }

          this.validateOwnerList();
        },

        error: (error) => {
          this._toastr.error(error?.message);
        }
      });
  }

  validateOwnerList() {                                                 //Developer: Sasmit, Ticket: CUST-11033, Date: 27-May-2026
    const savedOwnerId = this.jobDataModal.statusOwnerId;
    const filteredUsers = this.common.validateUserList(
      this.ownerData.filter((item: any) => item.Id !== 0) as any[],
      [savedOwnerId?.toString()].filter(Boolean),
      {
        userIdKey: 'Id',
        statusKey: 'inviteStatus',
        isEditMode: this.isEditMode
      }
    );

    // Re-add the "Unassigned" entry at the beginning
    const unassignedEntry = this.ownerData.find((item: any) => item.Id === 0);
    this.validOwnerData = unassignedEntry
      ? [unassignedEntry, ...filteredUsers]
      : filteredUsers;
  }

  eventChangeOwner(event: any) {
    if (!event) return;
    this.jobDataModal.statusOwnerId = event.Id;
  }
}

type BreakdownType = 'Role' | 'Assignee' | 'Estimate' | '';

class JobsAssignUser {
  public jobId: number;
  public assignUserIds: string;
}
class AssigneeDetails {
  userId: any = 0;
  name: any;
  role: any;
  rateperHour: any = 0;
  time: any;
  cost: any;
  isManagerPartner: any;
  isFirstUserForRole?: boolean = false;
  isTimesheetEntry?: boolean = false;
  _billrateId?: number;
  multiBillrates?: any;

  roleName?: string;
  unit?: number;
  taskId?: number;
  jobLevelRoleId?: number;
}

class AssignAndEstimate {
  Assign = new class Assign {
    _totalUnit: number = 0;

    staff: AssignedUser[] = [];

    unassigned = new class Unassigned {
      cost: string;
      unit: any;
      time: any;
    }
  };
  Estimate: EstimateTaskGroup[] = [];
};
class EstimateTask {
  taskId: number | string = 0;
  taskgroupId: number | string = 0;
  templateTaskId: number | string;
  taskTypeId: number = 0;
  sequence: number = 0;
  taskName: string = "";
  unit: any = 0;
  assignedUnit: any = 0;
  taskCategory: number;
  startAfterDays: number;
  dueAfterDays: number;
  _breakdownAvailableType: BreakdownType = '';
  _breakdownOpenType: BreakdownType = '';
  _assignedEstimates?: EstimateTaskData[] = []
  estimateData: string = '[]';
  _estimateDataList: EstimateTaskData[] = [];
  _estimateDataListUnsaved: EstimateTaskData[] = [];
  _unitUnsaved: any = 0;
  _taskRoleNames: string = '';
}
class EstimateTaskData {
  roleId: number = 0;
  roleName: string = null;
  _availableRoles: RolePermissions[] = [];
  userId: string = null;
  fullName: string = '';
  initials?: string = null;
  _availableUsers?: any[] = []
  unit: any = 0;
  time: any = 0;
}

class UserEstimateRequest {
  taskid: any = 0;
  taskgroupid: any = 0;
  userid: string = "";
  time: any = '';
  cost: number = 0;
  unit: number = 0;
  rate: number = 0;
  jobLevelRoleId: number = 0;
  isFirstUserForRole?: number = 0;
}

class EstimateTaskGroup {
  taskgroupId: number | string = 0;
  sequence: number = 0;
  taskGroupName: string = '';

  tasks: EstimateTask[] = [];

  _groupAssigneeOverview: any[] = [];
}
class RecurranceRequest {
  FY: string;
  Frequency: string = 'Monthly';
  PeriodForDisplay: string = '';
  Period: {
    PeriodVal: string;
    JobId: number;
    NewJobId: number;
    IsRecurrenceCreated: boolean;
  }[] = [];
  Start_ReccDate: any;
  Stop_ReccDate: any;
  TaskCarryForward: string = 'None';
  AssigneeCarryForward: string = 'None';
  BudgetCarryForward: string = 'None';
  CustomPeriod: {
    PeriodMonth: number,
    StartOn: number,
    DayName: number,
    StartMonth: number,
    EndType: number,
    EndMonth: number,
    EndOn: number,
    DayCount: number,
  }[] = [];
}
class FrequencyRequest {
  FY: string;
  Frequency: string = 'Monthly';
  PeriodForDisplay: string = '';
  Period: {
    PeriodVal: string;
    JobId: number;
    NewJobId: number;
    IsRecurrenceCreated: boolean;
  }[] = [];
  Start_ReccDate: any;
  Stop_ReccDate: any;
  TaskCarryForward: string = 'None';
  AssigneeCarryForward: string = 'None';
  BudgetCarryForward: string = 'None';
  CustomPeriod: {
    PeriodMonth: number,
    StartOn: number,
    DayName: number,
    StartMonth: number,
    EndType: number,
    EndMonth: number,
    EndOn: number,
    DayCount: number,
  }[] = [];
}
